const fr: Record<string, string> = {
  // nav
  'nav.overview': 'Aperçu',
  'nav.members': 'Membres',
  'nav.debates': 'Débats',
  'nav.bills': 'Objets',
  'nav.votes': 'Votes',
  'nav.parties': 'Partis',
  'nav.sessions': 'Sessions',
  'nav.committees': 'Commissions',
  'nav.chatHistory': 'Historique chat',
  'nav.reports': 'Rapports',
  'nav.usage':       'Utilisation',
  'nav.feedback':    'Retours',
  'nav.documentation': 'Docs',
  'settings.api.title':       'État de l\'API',
  'settings.api.health':      'Santé du backend',
  'settings.api.desc':        'Sondé toutes les 60 secondes. Combine la disponibilité Postgres et Meilisearch.',
  'settings.api.ok':          'Tous les systèmes opérationnels',
  'settings.api.degraded':    'Partiellement dégradé',
  'settings.api.unreachable': 'Inaccessible',
  // Page admin de triage des retours (/feedback)
  'feedback.title':              'Triage des retours',
  'feedback.subtitle':           'Tours du chat avec retour négatif, associés à la question utilisateur.',
  'feedback.window':             'Période',
  'feedback.errorLoad':          'Échec du chargement des retours',
  'feedback.kpiDownvotes':       'Avis négatifs',
  'feedback.noPrior':            'pas de données antérieures',
  'feedback.vsPrior':            'vs période précédente',
  'feedback.kpiRatio':           'Taux négatif',
  'feedback.rated':              'évalué(s)',
  'feedback.kpiWithComment':     'Avec commentaire',
  'feedback.commentSub':         'avec texte libre',
  'feedback.kpiTopCategory':     'Catégorie principale',
  'feedback.topCategorySub':     'problème le plus signalé',
  'feedback.categoryHistogram':  'Par catégorie',
  'feedback.clearCategory':      'Effacer le filtre',
  'feedback.chartHint':          'Cliquez sur une barre pour filtrer la liste.',
  'feedback.empty':              'Aucun avis négatif sur cette période.',
  'feedback.hasComment':         'commentaire',
  'feedback.openConversation':   'Ouvrir la conversation',
  'feedback.userLabel':          'Utilisateur',
  'feedback.assistantLabel':     'Assistant',
  'feedback.noUserQuery':        '(pas de question utilisateur précédente)',
  'feedback.noAssistantText':    '(pas de réponse textuelle — tour outil uniquement)',
  'feedback.withComment':        'Avec commentaire',
  'feedback.filterCommentOn':    'Afficher uniquement les éléments avec commentaire libre',
  'feedback.filterCommentOff':   'Affichage filtré sur commentaires — cliquer pour effacer',
  'feedback.conversation':       'Conversation',
  'feedback.openInChatHistory':  "Ouvrir dans l'historique",
  'feedback.turns':              'tours Q-R',
  'common.previous':             'Précédent',
  'common.next':                 'Suivant',
  'common.close':                'Fermer',
  'nav.settings': 'Paramètres',
  // Affordances de feedback (👍 / 👎 / copier + modale de catégorisation)
  'chat.feedback.helpful':            'Marquer comme utile',
  'chat.feedback.reportProblem':      'Signaler un problème',
  'chat.feedback.copy':               'Copier la réponse',
  'chat.feedback.copied':             'Copié',
  'chat.feedback.modal.title':        'Quel était le problème ?',
  'chat.feedback.modal.hint':         "Catégorisez le problème (facultatif) et ajoutez des détails. Tout est facultatif — un simple 👎 est aussi un signal utile.",
  'chat.feedback.modal.category':     'Catégorie',
  'chat.feedback.modal.comment':      'Commentaire (facultatif)',
  'chat.feedback.modal.commentPlaceholder': "Qu'est-ce qui n'allait pas, qu'attendiez-vous ?",
  'chat.feedback.modal.cancel':       'Annuler',
  'chat.feedback.modal.submit':       'Envoyer',
  'chat.feedback.cat.inaccurate':                 'Inexact',
  'chat.feedback.cat.inaccurate.desc':            'Fait erroné ou donnée inventée',
  'chat.feedback.cat.incomplete':                 'Incomplet',
  'chat.feedback.cat.incomplete.desc':            "N'a répondu qu'à une partie de la question",
  'chat.feedback.cat.wrong_citation':             'Mauvaise citation',
  'chat.feedback.cat.wrong_citation.desc':        "Lien source rompu ou pointant vers la mauvaise entité",
  'chat.feedback.cat.off_topic':                  'Hors sujet',
  'chat.feedback.cat.off_topic.desc':             "N'a pas répondu à la question posée",
  'chat.feedback.cat.formatting':                 'Mise en forme / langue',
  'chat.feedback.cat.formatting.desc':            'Mauvaise langue, tableau cassé, etc.',
  'chat.feedback.cat.other':                      'Autre',
  'chat.feedback.cat.other.desc':                 'Précisez dans le commentaire',
  'chat.history.pinned':              'Épinglés',
  'chat.history.today':               'Aujourd\'hui',
  'chat.history.yesterday':           'Hier',
  'chat.history.thisWeek':            'Cette semaine',
  'chat.history.older':               'Plus anciens',
  'chat.fromChat':                    'depuis le chat',
  'common.search':                    'Recherche',
  'chat.history.newChat':             'Nouveau chat',
  'chat.history.searchPlaceholder':   'Rechercher des sessions…',
  'chat.history.empty':               'Aucune conversation enregistrée. Démarrez-en une via le widget chat.',
  'chat.history.untitled':            'Chat sans titre',
  'chat.history.pin':                 'Épingler',
  'chat.history.unpin':               'Désépingler',
  'chat.history.rename':              'Renommer',
  'chat.history.archive':             'Archiver',
  'chat.history.selectHint':          'Sélectionnez une conversation dans la liste pour la lire. Les nouveaux chats démarrent dans le widget en bas à droite.',
  'chat.history.continue':            'Continuer dans le chat',
  'reports.listTitle':             'Rapports',
  'reports.empty':                 'Aucun rapport pour le moment. Sélectionnez des conversations dans l’historique du chat et générez-en un.',
  'reports.untitled':              'Rapport sans titre',
  'reports.selectHint':            'Sélectionnez un rapport pour le lire, ou générez-en un nouveau à partir de vos conversations dans l’historique du chat.',
  'reports.generatedOn':           'Généré le',
  'reports.sourcesNote':           'Les sources renvoient au site officiel du Parlement suisse (parlament.ch). Généré par IA à partir de conversations enregistrées — à vérifier avec les sources citées.',
  'reports.modelTip':              'Modèle choisi automatiquement selon la taille du rapport',
  'reports.downloadPdf':           'PDF',
  'reports.downloadMd':            'Markdown',
  'reports.popupBlocked':          'Veuillez autoriser les fenêtres pop-up pour ce site afin de télécharger le PDF.',
  'reports.status.failed':         'échec',
  'reports.confirmDelete':         'Supprimer ce rapport ? Cette action est irréversible.',
  'reports.generateTitle':         'Générer un rapport',
  'reports.generateHint':          'Un rapport de recherche professionnel sera rédigé à partir de la conversation sélectionnée, organisé par thème. Il ne cite que des sources officielles parlament.ch.',
  'reports.turnsSelected':         'Échanges sélectionnés',
  'reports.conversationsSelected': 'Conversations sélectionnées',
  'reports.language':              'Langue du rapport',
  'reports.lang.de':               'Allemand',
  'reports.lang.fr':               'Français',
  'reports.lang.it':               'Italien',
  'reports.lang.en':               'Anglais',
  'reports.generate':              'Générer le rapport',
  'reports.generating':            'Génération…',
  'reports.generateError':         'Impossible de générer le rapport. Veuillez réessayer.',
  'reports.selectSessions':        'Sélectionner pour le rapport',
  'reports.selectTurns':           'Sélectionner pour le rapport',
  'reports.selectDone':            'Terminer la sélection',
  'reports.generateN':             'Générer le rapport ({n})',
  'reports.turnsChosen':           '{n} échange(s) sélectionné(s)',
  'common.cancel':                 'Annuler',
  'common.delete':                 'Supprimer',
  'debates.tab.search':                 'Recherche',
  'debates.tab.trends':                 'Tendances',
  // Trends — compare-factions toggle
  'debates.trends.compareLabel':     '+ comparer',
  'debates.trends.exitCompare':      '× comparer',
  'debates.trends.compareTooltip':   'Comparer plusieurs groupes côte à côte',
  'common.errorLoad':                            'Échec du chargement',
  'debates.trends.title':               'Tendances rhétoriques',
  'debates.trends.subtitle':            'Évolutions annuelles dans la parole parlementaire — sentiment, position, orientation fédéraliste, intensité émotionnelle.',
  'debates.trends.empty':               'Aucun discours ne correspond aux filtres actuels.',
  'debates.trends.allFactions':         'Groupes',
  'debates.trends.allParties':          'Partis',
  'debates.trends.allSessions':         'Sessions',
  'debates.trends.councillorPlaceholder': 'Nom du conseiller…',
  'debates.trends.chunksHint':            'Segments analysés par IA dans ces discours (les longs discours sont fragmentés pour l\'analyse)',
  'faction.cohesion':                'Cohésion',
  'faction.rebels':                  'Dissidents',
  'faction.cohesionByYear':          'Par année',
  'faction.cohesionByTopic':         'Par thème',
  'faction.cohesionYearSubtitle':    'Cohésion par année — part des votes exprimés alignés sur la majorité du groupe.',
  'faction.cohesionTopicSubtitle':   'Cohésion par domaine politique — les plus faibles révèlent les sujets les plus clivants en interne.',
  'faction.cohesionSrNote':          'Les données de vote nominal du Conseil des États ne commencent qu\'en 2022.',
  'faction.rebelsSubtitle':          'Membres classés par fréquence d\'écart par rapport à la majorité du groupe (votes Oui/Non). Votes à égalité exclus ; minimum 20 votes Oui/Non exprimés.',
  'faction.allChambers':             'Deux conseils',
  'faction.rebellionRate':           'Taux d\'écart',
  'faction.rebellionRateTip':        'Écarts ÷ Oui/Non exprimés — part des votes Oui/Non où le membre a rompu les rangs.',
  'faction.rebellionDiverges':       'Écarts',
  'faction.rebellionDivergesTip':    'Nombre de votes Oui/Non où le membre s\'est opposé à la majorité du groupe.',
  'faction.rebellionVotes':          'Oui/Non',
  'faction.rebellionVotesTip':       'Votes Oui/Non personnellement exprimés par le membre et pris en compte dans ce classement. Les abstentions et votes où le groupe était à égalité sont exclus — d\'où l\'écart avec le total « Au registre » de la fiche du membre.',
  'faction.votes':                   'votes',
  'parties.unityRanking':            'Classement d\'unité des groupes',
  'parties.unityRankingTip':         'Unité de vote de chaque groupe par chambre (Conseil national et Conseil des États). Données du Conseil des États depuis 2022. Cliquez sur une barre pour ouvrir le groupe.',
  'votes.demographics.title':        'Statistiques',
  'votes.demographics.subtitle':     'comment ce vote s\'est réparti au conseil',
  'votes.demographics.notParticipating': 'N\'a pas participé',
  'votes.demographics.total':        'Total',
  'votes.demographics.tenure':       'Ancienneté',
  'tenure.bucket.veteran':           'Sortants',
  'tenure.bucket.newcomer':          'Nouveaux élus',
  'member.member':                   'Membre',
  'bills.tab.search':                'Recherche',
  'bills.tab.analytics':             'Analyse',
  'bills.analytics.title':           'Analyse des objets',
  'bills.analytics.subtitle':        'Répartition des dépôts par thème, année, type, département ou intention.',
  'bills.analytics.clickToFilter':   'Cliquer pour filtrer',
  'bills.analytics.yearRange':       'Années',
  'bills.analytics.yearFrom':        'Année de début',
  'bills.analytics.yearTo':          'Année de fin',
  'bills.analytics.allYears':        'Toutes',
  'common.clear':                    'Effacer',
  'bills.analytics.submissions':     'Dépôts',
  'bills.analytics.concluded':       'Conclu',
  'bills.analytics.metricsTooltip':  'Dépôts compte les objets déposés par groupe sur la période choisie. Conclu indique combien d\'entre eux ont depuis été réglés (statut « Erledigt »), avec la part entre parenthèses.',
  'bills.analytics.topic':           'Thème',
  'bills.analytics.year':            'Année',
  'bills.analytics.affairType':      'Type',
  'bills.analytics.department':      'Département',
  'bills.analytics.intent':          'Intention',
  'bills.analytics.faction':         'Groupe',
  'bills.analytics.party':           'Parti',
  'bills.analytics.canton':          'Canton',
  'bills.analytics.council':         'Conseil',
  'bills.analytics.councillor':      'Conseiller·ère',
  'bills.analytics.committee':       'Commission',
  'bills.analytics.hiddenDimTip':    'Appliqué via le chatbot. Passer à une dimension visible pour quitter.',
  'bills.legislativePeriod':         'Législature',
  'bills.allLegPeriods':             'Législatures',
  'bills.dateRange':                 'Date',
  'bills.fcRecommendation':          'Recommandation CF',
  'bills.committeeRecommendation':   'Recommandation Commission',
  'filter.tooltip.legislativePeriod': 'Filtrer par législature (52=2023→, 51=2019–23, 50=2015–19)',
  'parties.composition.title':       'Composition du conseil',
  'debates.trends.scoreAxis':           'Score',
  'debates.trends.emotionalityAvg':     'Émotion. moy.',
  'debates.trends.metric.sentiment':    'Sentiment',
  'debates.trends.metric.alignment':    'Position',
  'debates.trends.metric.federalism':   'Fédéralisme',
  'debates.trends.metric.emotionality': 'Émotivité',
  // anchor
  'anchor.researching': 'Recherche\u00a0:',
  'anchor.clear': 'Effacer',
  // common
  'common.all': 'Tous',
  'common.impact': 'Impact',
  'common.sensitivity': 'Polarisation',
  'common.centralization': 'Fédéralisme',
  'common.centralizShort': 'Fédéralisme',
  'common.impact.tooltip': "Dans quelle mesure ce projet affecte la société, l'économie ou la législation suisse. 1 = mineur/limité, 10 = majeur/étendu.",
  'common.sensitivity.tooltip': 'Degré de controverse ou de division politique de ce sujet. 1 = non controversé, 10 = très polarisant.',
  'common.centralization.tooltip': "Direction du transfert de pouvoir. 1 = fortement cantonal/local, 10 = fortement fédéral/centralisé.",

  // Phase 4.5 — Badges d'anomalies classifiées par IA
  'anomaly.controversial':            'Controversé',
  'anomaly.controversial.tooltip':    "Évalue la tendance polarisante de l'objet pour la société suisse (économie, politique, droit et culture). 1 = faible polarisation / 10 = forte polarisation",
  'anomaly.polarizing':               'Polarisant',
  'anomaly.polarizing.tooltip':       "Évalue la tendance polarisante de l'objet pour la société suisse (économie, politique, droit et culture). 1 = faible polarisation / 10 = forte polarisation",
  'anomaly.highImpact':               'Impact',
  'anomaly.highImpact.tooltip':       "Évalue l'incidence de l'objet sur la société suisse (économie, politique, droit et culture). 1 = incidence limitée / 10 = incidence considérable",
  'anomaly.centralizing':             'Centralisateur',
  'anomaly.centralizing.tooltip':     "Évalue si l'objet uniformise et centralise la société suisse (économie, politique, droit et culture). 1 = renforcement du fédéralisme / 10 = extension du centralisme",
  'anomaly.decentralizing':           'Fédéraliste',
  'anomaly.decentralizing.tooltip':   "Évalue si l'objet uniformise et centralise la société suisse (économie, politique, droit et culture). 1 = renforcement du fédéralisme / 10 = extension du centralisme",
  'anomaly.minorityReport':           'Rapport de minorité',
  'anomaly.minorityReport.tooltip':   "Une minorité de la commission a déposé une opposition écrite (« bekämpft ») — l'objet porte une contre-proposition au-delà de la position majoritaire.",
  'anomaly.fastTracked':              'Procédure accélérée',
  'anomaly.fastTracked.tooltip':      "Résolu exceptionnellement vite — moins de 90 jours entre dépôt et vote final. Souvent un indice de procédure d'urgence.",
  'anomaly.heated':                   'Animé',
  'anomaly.heated.tooltip':           'Discours chargé émotionnellement — émotivité 7–8 sur 10.',
  'anomaly.confrontational':          'Conflictuel',
  'anomaly.confrontational.tooltip':  'Ton fortement conflictuel — émotivité 9 ou 10 sur 10.',
  'anomaly.closeVote':                'Vote serré',
  'anomaly.closeVote.tooltip':        "Décidé à moins de 5% d'écart entre Oui et Non — quelques voix auraient inversé le résultat.",
  'anomaly.rapporteur':               'Rapporteur',
  'anomaly.rapporteur.tooltip':       "Porte-parole officiel de la commission présentant l'objet en plénière — le discours porte la position formelle de la commission.",
  'common.submittedBy': 'Soumis par',
  'common.department': 'Département',
  'common.status': 'Statut',
  'common.trigger': 'Déclencheur',
  'common.words': 'mots',
  'common.back': 'Retour',
  'common.active': 'Actif',
  'common.loading': 'Chargement…',
  'common.loadMore': 'Charger plus',
  'common.clearAll': 'Tout effacer',
  'common.retry': 'Réessayer',
  'common.error.title': 'Une erreur est survenue',
  'common.error.body': 'Ce contenu n’a pas pu être chargé. Veuillez réessayer.',
  'council.NR': 'Conseil national',
  'council.SR': 'Conseil des États',
  'council.V': 'Assemblée fédérale (Chambres réunies)',
  'council.BR': 'Conseil fédéral',
  'filter.tooltip.party':     'Filtrer par affiliation politique. Plusieurs partis sélectionnables ensemble.',
  'filter.tooltip.faction':   'Filtrer par groupe parlementaire (V·UDC, S·PS, RL·PLR, M-E·Centre, G·Verts, GL·PVL).',
  'filter.tooltip.canton':    'Filtrer par canton de représentation. Plusieurs cantons pour comparaisons croisées.',
  'filter.tooltip.council':   'Conseil national vs Conseil des États. Sélectionner les deux pour tous les parlementaires.',
  'filter.tooltip.gender':    'Filtrer les membres par genre.',
  'filter.tooltip.committee': 'Filtrer par appartenance actuelle aux commissions. Plusieurs pour intersections.',
  'filter.year':              'Année',
  'filter.session':           'Session',
  'filter.tooltip.year':      'Année de dépôt de l\'objet — quand il a été introduit pour la première fois. Pas l\'année du dernier traitement ou du dernier vote.',
  'filter.tooltip.session':   'Type de session dans l\'année (Printemps, Été, Automne, Hiver).',
  'filter.tooltip.status':    'Actif = membres en exercice. Anciens = anciens membres uniquement.',
  // Bills page (4.8 + IWP Bundle 1)
  'filter.tooltip.billType':            'Type d\'instrument parlementaire : Motion, Postulat, Interpellation, Initiative parlementaire, etc. Plusieurs types peuvent être combinés.',
  'filter.tooltip.billStatus':          'État procédural actuel de l\'objet (déposé, en cours, accepté, rejeté, retiré).',
  'filter.tooltip.department':          'Département ou office fédéral compétent.',
  'filter.tooltip.number':              'Filtrer par numéro d\'objet exact, ex. 24.3145. Les jokers ne sont pas pris en charge.',
  'filter.tooltip.submittedBy':         'Filtrer par auteur — conseiller, groupe ou institution comme le Conseil fédéral ou une commission parlementaire.',
  'filter.tooltip.aiTopic':             'Domaine politique classé par IA (santé, énergie, migration, etc.). Un thème dominant par objet.',
  'filter.tooltip.aiIntent':            'Intention de l\'objet classée par IA (proposer une nouvelle loi, demander un rapport, poser une question).',
  'filter.tooltip.aiAudience':          'Public cible de l\'objet classé par IA (citoyens, entreprises, cantons, etc.).',
  'filter.tooltip.aiTrigger':           'Déclencheur externe classé par IA (arrêt judiciaire, directive UE, événement public, etc.).',
  'filter.tooltip.aiMinImpact':         'Score minimal d\'impact (1–10). Dans quelle mesure l\'objet modifie le droit suisse ou la politique publique. Noté par IA.',
  'filter.tooltip.aiMinSensitivity':    'Score minimal de sensibilité politique (1–10). Degré de controverse politique ou de tension entre partis. Noté par IA.',
  'filter.tooltip.aiMinCentralization': 'Score minimal de centralisation (1–10). Dans quelle mesure l\'objet déplace les compétences vers le niveau fédéral.',
  // Votes page (4.8 + IWP Bundle 1)
  'filter.tooltip.voteYear':            'Année du vote (date du vote), indépendamment de l\'année de dépôt de l\'objet.',
  'filter.tooltip.voteStatus':          'Résultat du vote : accepté, rejeté, voix égales ou en attente.',
  'filter.tooltip.voteKeyword':         'Recherche en texte intégral dans les titres de vote et les titres des objets sous-jacents.',
  'filter.tooltip.closeOnly':           'Afficher uniquement les votes serrés — écart de 10 voix ou moins entre Oui et Non.',
  'filter.tooltip.splitOnly':           'Afficher uniquement les votes où au moins un groupe était divisé en interne de plus de 20%.',
  // Debates page (4.8 + IWP Bundle 1)
  'filter.tooltip.debateYear':          'Année du débat.',
  'filter.tooltip.language':            'Langue du discours (DE, FR, IT).',
  'filter.tooltip.speaker':             'Filtre en texte intégral sur le nom de l\'orateur (le nom de famille suffit).',
  'filter.tooltip.role':                'Rôle de l\'orateur dans le débat : rapporteur, conseiller fédéral, membre ordinaire, etc.',
  'filter.tooltip.sentiment':           'Ton général du discours classé par IA : positif, neutre ou négatif.',
  'filter.tooltip.position':            'Position vis-à-vis de l\'objet débattu : Pour, Soutien conditionnel, Neutre ou Contre.',
  'filter.tooltip.federalism':          'Orientation fédéraliste du discours : favorable au fédéral (centralisation) ou aux cantons (décentralisation).',
  'filter.tooltip.amendment':           'Afficher uniquement les discours où un amendement a été explicitement proposé.',
  'filter.tooltip.businessFilter':      'Filtrer les discours par numéro d\'objet sous-jacent (ex. 24.3145).',
  // Sessions page (4.8 + IWP Bundle 1)
  'filter.tooltip.sessionYear':         'Année à laquelle la session a eu lieu.',
  'filter.tooltip.season':              'Type de session : session ordinaire de printemps/été/automne/hiver, ou session extraordinaire.',
  // Committees page (4.8 + IWP Bundle 1)
  'filter.tooltip.committeeType':       'Type de commission : commission permanente, commission de surveillance ou autre organe spécial.',
  'filter.tooltip.committeeActive':     'Filtrer selon que la commission est actuellement active ou a été dissoute/remplacée.',
  'filter.tooltip.commission':          'Filtrer par commission permanente principale (p. ex. CPE) et tous ses organes — les deux conseils, sous-commissions et groupes de travail.',
  // Generic
  'filter.tooltip.search':              'Recherche en texte intégral sur les champs nom. Nom de famille et correspondances partielles fonctionnent.',
  // SessionPicker (IWP Bundle 2)
  'filter.allSessions':                 'Sessions',
  'filter.tooltip.sessionPicker':       'Filtrer sur une session précise. Choisissez l\'année, puis dépliez pour voir les sessions de printemps, d\'été ou extraordinaires.',
  // SessionDetail — highly-relevant bills card (IWP Bundle 2)
  'session.highlights.title':           'Objets les plus importants de cette session',
  'session.highlights.subtitle':        'Objets à l\'ordre du jour de cette session, classés par l\'IA selon leur portée (impact) et leur polarisation politique.',
  'session.highlights.empty':           'Aucun objet à fort impact ou forte polarisation à l\'ordre du jour de cette session.',
  'empty.noResultsTitle': 'Aucun résultat pour ces filtres',
  'empty.noResultsHint':  'Essayez de retirer un ou plusieurs filtres pour élargir la recherche.',
  'empty.removeFilter':   'Retirer ce filtre',
  'presets.save':              'Enregistrer le filtre',
  'presets.saveTooltip':       'Enregistrer les filtres actuels comme préréglage',
  'presets.dropdown':          'Préréglages',
  'presets.applyHeading':      'Appliquer un préréglage',
  'presets.manageHint':        'Gérer dans Paramètres → Préréglages',
  'presets.modal.title':       'Enregistrer le filtre',
  'presets.modal.nameLabel':   'Nom',
  'presets.modal.namePlaceholder': 'ex. Motions UDC migration T1 2025',
  'presets.modal.hint':        'Enregistrer avec un nom existant écrase ce préréglage.',
  'presets.modal.cancel':      'Annuler',
  'presets.modal.save':        'Enregistrer',
  'presets.modal.saving':      'Enregistrement…',
  'common.results': 'résultats',
  'common.filteredBy': 'Filtré par',

  // ── Notifications / liste de suivi ────────────────────────────────────
  'notif.bell.aria':                 'Notifications',
  'notif.bell.unread':               'non lues',
  'notif.dropdown.title':            'Notifications',
  'notif.dropdown.markAllRead':      'Tout marquer comme lu',
  'notif.dropdown.empty':            'Aucune nouvelle activité.',
  'notif.dropdown.viewAll':          'Voir toutes les notifications',
  'notif.row.voteResult':            'Vote final sur {affair} — {title}',
  'notif.row.billStatus':            '{affair} — {title} : statut changé en {status}',
  'notif.row.sessionReminder':       'Session bientôt : {name}',
  'notif.row.memberVote':            '{member} a voté {decision} sur {affair} — {title}',
  'notif.row.memberSpeech':          '{member} a pris la parole sur {affair} — {title}',
  'notif.row.generic':               'Nouvel événement sur un objet suivi',
  'notif.detail.voteTallies':        'Oui {yes} · Non {no} · Abstention {abs}',
  'notif.detail.statusChange':       'De « {from} » à « {to} »',
  'notif.page.title':                'Notifications',
  'notif.page.subtitle':             'Événements sur les objets, votes et membres que vous suivez.',
  'notif.page.onlyUnread':           'Non lues uniquement',
  'notif.page.markAllRead':          'Tout marquer comme lu',
  'notif.page.empty':                'Aucune notification pour le moment.',
  'notif.page.emptyUnread':          'Aucune notification non lue.',
  'notif.page.emptyHint':            'Cliquez sur le signet d\'un objet pour commencer à le suivre.',
  'watch.watch':                     'Suivre',
  'watch.watching':                  'Suivi',
  'watch.full':                      'Liste pleine (max 100)',
  'watch.error':                     'Impossible de mettre à jour — réessayez',
  // Modale de gestion de la liste de suivi (ouverte depuis Paramètres → Gérer)
  'watchlist.modal.title.bills':     'Objets suivis',
  'watchlist.modal.title.members':   'Membres suivis',
  'watchlist.modal.title.votes':     'Votes suivis',
  'watchlist.modal.empty.bills':     "Vous ne suivez encore aucun objet.",
  'watchlist.modal.empty.members':   "Vous ne suivez encore aucun membre.",
  'watchlist.modal.empty.votes':     "Vous ne suivez encore aucun vote.",
  'watchlist.modal.emptyHint':       "Cliquez sur l'icône de signet d'une page détaillée pour commencer à suivre.",
  'watchlist.modal.unavailable':     'Indisponible',
  'watchlist.modal.open':            'Ouvrir',
  'watchlist.modal.remove':          'Retirer',
  'watchlist.modal.close':           'Fermer',
  'watchlist.modal.done':            'Terminé',
  'watchlist.modal.filterBy':        'Filtre',
  'watchlist.modal.clearFilter':     'Effacer le filtre',
  'watchlistTagFilter.label':        'Étiquettes',
  'watchlistTagFilter.activeLabel':  '{n} étiquette(s)',
  'watchlistTagFilter.dropdownTitle':'Vos étiquettes de suivi',
  'watchlistTagFilter.clear':        'Effacer',
  'watchlistTagFilter.andHint':      'Les éléments doivent porter toutes les étiquettes sélectionnées.',
  'watchlistTagFilter.banner':       'Liste de suivi · {n} {kind}',
  'watchlistTagFilter.taggedLabel':  'étiquetés',
  'watchlistTagFilter.emptyMatch':   'Aucun élément suivi ne correspond à ces étiquettes.',
  'watchlistTagFilter.emptyMatchHint':"Retirez une étiquette du filtre ou ajoutez plus d'éléments via la modale de la liste de suivi.",
  'tags.selector.title':             'Étiquettes',
  'tags.selector.noneYet':           "Aucune étiquette — créez-en une dans Paramètres → Notifications → Étiquettes.",
  'tags.selector.createNew':         'Créer une étiquette',
  'tags.selector.namePlaceholder':   "Nom de l'étiquette",
  'tags.selector.create':            'Créer',
  'tags.selector.cancel':            'Annuler',
  'tags.atCap':                      'max 10',
  'tags.full':                       'Limite atteinte (max 10 étiquettes par élément)',
  'tags.duplicate':                  'Une étiquette portant ce nom existe déjà',
  'tags.error':                      'Impossible de mettre à jour — réessayez',
  'tagsManager.header':              'Vos étiquettes',
  'tagsManager.empty':               "Aucune étiquette pour le moment. Cliquez sur « Créer une étiquette » ci-dessus pour organiser vos objets et membres suivis.",
  'tagsManager.hint':                "La suppression d'une étiquette la retire de tous les éléments où elle était attachée.",
  'tagsManager.confirmDelete':       "Supprimer l'étiquette « {name} » ? Elle sera retirée de tous les éléments où elle était attachée.",
  'tagsManager.edit':                'Renommer / recolorer',
  'tagsManager.delete':              "Supprimer l'étiquette",
  'tagsManager.save':                'Enregistrer',
  'tagsManager.cancel':              'Annuler',
  'tagsManager.create':              'Créer une étiquette',
  'tagsManager.namePlaceholder':     "Nom de l'étiquette",
  'tagsManager.color':               'Couleur',
  'tagsManager.userCapReached':      'Limite atteinte (max 30 étiquettes par utilisateur)',
  // Étiquettes des puces de filtre — voir note dans en.ts : les puces
  // affichaient le texte brut de la clé parce que useT() retourne la clé
  // elle-même lorsqu'elle est manquante, pas le suffixe `|| 'Fallback'`.
  'bills.affairNumber':       "N° d'objet",
  'bills.type':               "Type d'objet",
  'bills.status':              'Statut',
  'bills.department':         'Département',
  'filter.language':          'Langue',
  'filter.status':            'Statut',
  'debates.role':             'Rôle',
  'chat.provenanceTooltip':   'Filtres appliqués depuis une suggestion du chatbot',
  'common.noResults': 'Aucun résultat trouvé.',
  'common.clearFilters': 'Effacer les filtres',
  'common.current': 'Actuel',
  'common.past': 'Passé',
  'common.present': 'Aujourd\'hui',
  'common.exportCSV': 'Exporter en CSV',
  'csv.filtersApplied': 'Filtres appliqués',
  'csv.noFilters': 'Aucun (tous les résultats)',
  'csv.legislature': 'Législature',
  'csv.vote': 'Vote',
  'csv.outcome': 'Résultat',
  // filters
  'filter.allParties': 'Partis',
  'filter.allCantons': 'Cantons',
  'debates.partyTooltip':  'Filtrer les discours par parti de l\'orateur. S\'applique à la vue tendances ; la liste se regroupe par groupe parlementaire.',
  'debates.cantonTooltip': 'Filtrer les discours par canton de l\'orateur.',
  'filter.allFactions': 'Groupes',
  'filter.allCouncils': 'Conseils',
  'filter.allGenders': 'Genres',
  'filter.allYears': 'Années',
  'filter.allMembers': 'Membres',
  'filter.allCommittees': 'Commissions',
  'filter.committee': 'Commission',
  'filter.activeOnly': 'Actif',
  'filter.formerOnly': 'Anciens',
  'sort.by': 'Trier par',
  'sort.name': 'Nom',
  'sort.joined': 'Année d\'entrée',
  'sort.cohesion': 'Cohésion',
  'sort.dob':'Date de naissance',
  'sort.ascending': 'Croissant',
  'sort.descending': 'Décroissant',
  'sort.submissionDate': 'Date de dépôt',
  'filter.canton': 'Canton (ex. ZH)',
  'filter.searchName': 'Rechercher par nom…',
  // omni search
  'omni.placeholder':  'Rechercher membres, objets, votes, discours…',
  'omni.scopeLabel':   'Rechercher dans',
  'omni.hint.members': 'Noms, partis, cantons',
  'omni.hint.bills':   'Objets par mot-clé',
  'omni.hint.votes':   'Titres de votes',
  'omni.hint.debates': 'Discours parlementaires',
  'omni.searching':    'Recherche en cours…',
  'omni.noResults':    'Aucun résultat pour',
  'omni.viewAll':      'Voir tout dans',
  'omni.kbdNav':       'naviguer',
  'omni.kbdOpen':      'ouvrir',
  'omni.kbdClose':     'fermer',
  'filter.party': 'Parti',
  'filter.faction': 'Groupe',
  'filter.canton.label': 'Canton',
  'filter.gender':  'Genre',
  'filter.council': 'Conseil',
  'filter.commission': 'Commission',
  'filter.allCommissions': 'Commissions',
  'filter.tooltip.commissionAffair': 'Filtrer par la commission parlementaire compétente.',
  // councils
  'council.nr': 'Conseil national',
  'council.sr': 'Conseil des États',
  'council.bundesrat': 'Conseil fédéral',
  // gender
  'gender.male': 'Homme',
  'gender.female': 'Femme',
  // members
  'members.title': 'Membres / Conseillers',
  'members.legislativePeriod': 'Législature',
  'members.interest':          'Intérêt',
  'members.interestMinCount':  'Intérêts',
  'members.occupation':        'Profession',
  'members.employer':          'Employeur',
  'members.nativeLanguage':    'Langue maternelle',
  'members.subtitle': 'Parcourir les membres actifs du parlement.',
  // member detail tabs
  'tab.profile': 'Profil',
  'tab.activity': 'Activité',
  'tab.partyHistory': 'Historique des partis',
  'tab.history': 'Historique',
  'history.dim.party': 'Parti',
  'history.dim.council': 'Conseil',
  'history.dim.legislation': 'Législature',
  'history.dim.commission': 'Commission',
  'history.legislature': 'Législature',
  'member.noHistory': 'Aucun historique pour ce filtre.',
  'tab.votingRecord': 'Comportement de vote',
  'tab.speeches': 'Discours',
  'tab.bills': 'Objets déposés',
  // member detail sections
  'member.occupations': 'Professions',
  'member.interests': 'Liens d\'intérêts',
  'member.noOccupations': 'Aucune donnée professionnelle disponible.',
  'member.born': 'Né(e)',
  'member.gender': 'Genre',
  'member.citizenship': 'Bourgeoisie',
  'member.nativeLang': 'Langue mat.',
  'member.marital': 'État civil',
  'member.children': 'Enfants',
  'member.military': 'Militaire',
  'member.elected': 'Élu(e)',
  'member.oath': 'Serment',
  'member.joined': 'Entrée',
  'member.left': 'Sortie',
  'member.allMembers': 'Membres',
  'member.totalVotes': 'Au registre',
  'member.totalVotesTip': 'Tous les votes inscrits au registre de ce membre, y compris absences et votes excusés. Le taux de présence indique la part de ces votes auxquels le membre a effectivement participé.',
  'member.cast': 'Exprimés',
  'member.castTip': 'Décisions Oui, Non et Abstention combinées — les votes que le membre a personnellement exprimés.',
  'member.yesRate': 'Taux oui',
  'member.yesRateTip': 'Part de l\'ensemble des votes au registre où le membre a voté Oui. Les absences font partie du dénominateur.',
  'member.noRate': 'Taux non',
  'member.noRateTip': 'Part de l\'ensemble des votes au registre où le membre a voté Non. Les absences font partie du dénominateur.',
  'member.abstainTip': 'Part de l\'ensemble des votes au registre où le membre s\'est abstenu. Les absences font partie du dénominateur.',
  'member.attendance': 'Présence',
  'member.attendanceTip': 'Part des votes auxquels le membre a participé (Oui, Non ou Abstention) sur l\'ensemble des votes possibles pendant son mandat.',
  'member.distribution': 'Distribution des votes',
  'member.paid': 'Rémunéré',
  'member.cohesion': 'Cohésion',
  'member.cohesionTip': 'À quelle fréquence ce membre vote-t-il avec la majorité de son groupe sur les décisions Oui/Non.',
  'member.withFaction': 'Avec le groupe',
  'member.withFactionTip': 'Votes Oui/Non où ce membre a voté AVEC la majorité de son groupe (nombre et part = cohésion).',
  'member.againstFaction': 'Contre le groupe',
  'member.againstFactionTip': 'Votes Oui/Non où ce membre a voté CONTRE la majorité de son groupe (nombre et part).',
  'member.withMajority': 'Avec la majorité',
  'member.withMajorityTip': 'Votes Oui/Non où le membre était du côté gagnant (majorité du conseil), indépendamment du groupe.',
  'member.withMinority': 'Avec la minorité',
  'member.withMinorityTip': 'Votes Oui/Non où le membre était du côté perdant (minorité du conseil).',
  'member.votesLoadError': 'Impossible de charger les votes.',
  'member.cohesionOverTime': 'Fidélité au groupe dans le temps',
  'member.cohesionChart.aligned': '{aligned} sur {base} votes du groupe',
  'member.cohesionChart.dissent': '{n} contre le groupe',
  'member.dissentOnly': 'Divergences uniquement',
  'member.dissentBadge': 'Divergence',
  'member.compare': 'Comparer',
  'member.compareBar': 'Comparer {n} membres',
  'member.compareHint': 'Sélectionner jusqu\'à 3 membres pour les comparer',
  'member.clearSelection': 'Effacer la sélection',
  'member.contact': 'Contact & Liens',
  'member.topTopics': 'Sujets principaux',
  'member.noPartyHistory': 'Aucun historique de parti disponible.',
  // debates
  'debates.title': 'Débats & Discours',
  'debates.subtitle': 'Recherchez des discours parlementaires par recherche sémantique IA.',
  'debates.searchPlaceholder': 'Recherche sémantique ou par numéro d\'objet (ex. \'politique climatique\', 25.041)',
  'debates.speakerPlaceholder': 'Nom de l\'intervenant',
  'debates.businessNumberPlaceholder': 'Numéro d\'objet (ex. 25.218)',
  'debates.emptyTitle': 'Rechercher des discours parlementaires',
  'debates.emptySubtitle': 'Utilisez la barre de recherche pour trouver des discours par thème, ou filtrez par intervenant, année ou conseil.',
  'debates.noResults': 'Aucun discours trouvé pour cette requête.',
  'debates.semanticMode': 'Recherche sémantique',
  'debates.allLangs': 'Langues',
  'debates.recentSpeeches': 'Discours récents',
  'debates.debateSessions': 'Sessions de débat',
  'debates.sessionUnknown': 'Session',
  'debates.loadingChronology': 'Chargement de la chronologie complète des débats…',
  'debates.loadingMoreDebates': 'Chargement d\'autres débats…',
  'debates.backToDebates': 'Retour aux débats',
  'debates.fullSpeech': 'Discours complet',
  'debates.topSpeakers': 'Orateurs principaux',
  'debates.topSpeakersOnTopic': 'Orateurs principaux sur ce sujet',
  'debates.factionActivity': 'Activité par groupe',
  'debates.contributionToTopic': 'Contribution au sujet',
  'debates.contributionOfTotal': '{count} interventions sur {total} sur ce sujet',
  'debates.contributionRank': 'Rang {rank} sur {total} orateurs sur ce sujet',
  'debates.speeches': 'discours',
  'debates.speakersCount': 'intervenants',
  'debates.newestFirst': 'Plus récents d\'abord',
  'debates.oldestFirst': 'Plus anciens d\'abord',
  'debates.debateThread': 'Fil du débat',
  'debates.speechesInDebate': 'discours dans ce débat',
  'debates.singleStatement': 'Intervention unique',
  'debates.singleStatementTip': 'Une seule intervention (généralement du président ou du rapporteur) — pas de débat.',
  'debates.viewSpeech': 'Voir le discours complet',
  'debates.match': 'correspondance',
  'debates.date': 'Date',
  'debates.council': 'Conseil',
  'debates.affair': 'Objet',
  'debates.current': 'actuel',
  'debates.unknownSpeaker': 'Orateur inconnu',
  'debates.noTranscript': 'Aucun texte disponible pour cette intervention.',
  'debates.noTranscriptShort': 'Aucun texte disponible.',
  'debates.viewOnParlament': 'Voir sur parlament.ch',
  'debates.parlamentCh': 'parlament.ch',
  'debates.searchCap': 'limite de l\'index de recherche',
  'debates.searchCapTip': 'La recherche plein texte retourne au maximum 1 000 résultats. Utilisez les filtres par année, conseil ou groupe pour affiner.',
  'debates.speechesPerMember': 'par membre',
  'debates.factionActivityNote': 'Largeur normalisée par taille du groupe',
  'debates.shareOfResults': 'Part des résultats',
  'debates.activeMembers': 'Membres actifs',
  'debates.filterByYear': 'Filtrer par année',
  // AI enriched metadata
  'debates.moreFilters': 'Plus de filtres',
  'debates.aiInsights': 'Aperçus IA',
  'debates.sentiment': 'Sentiment',
  'debates.position': 'Position',
  'debates.for': 'Pour',
  'debates.against': 'Contre',
  'debates.positive': 'Positif',
  'debates.negative': 'Négatif',
  'debates.amendments': 'amendements',
  'debates.proposed': 'proposés',
  'debates.stanceSummary': 'Résumé de position',
  'debates.federal': 'Fédéral',
  'debates.cantonal': 'Cantonal',
  'debates.federalismStance': 'Position fédéraliste',
  'debates.federalTip': "L'orateur plaide pour réglementer cela au niveau fédéral (centralisé) plutôt que de le laisser aux cantons.",
  'debates.cantonalTip': "L'orateur plaide pour laisser cela aux cantons (décentralisé) plutôt que de le réglementer au niveau fédéral.",
  'debates.emotionality': 'Émotivité',
  'debates.allRoles': 'Rôles',
  'debates.allSentiments': 'Sentiments',
  'debates.allPositions': 'Positions',
  'debates.allFederalism': 'Fédéralisme',
  'debates.federalism': 'Fédéralisme',
  // Codes de rôle non encore couverts ci-dessous (voir lib/debateEnums.ts).
  'debates.role.rapporteur': 'Rapporteur',
  'debates.role.procedural': 'Procédure',
  'debates.amendmentOnly': 'Amendement proposé',
  'debates.conditionalSupport': 'Soutien conditionnel',
  'debates.role.proponent': 'Partisan',
  'debates.role.critic': 'Critique',
  'debates.role.expert': 'Expert',
  'debates.role.mediator': 'Médiateur',
  'debates.role.stateRep': 'Représentant de l\'État',
  'common.neutral': 'Neutre',
  // bills
  'bills.title': 'Objets parlementaires',
  'bills.subtitle': 'Rechercher et parcourir les objets parlementaires.',
  'bills.searchPlaceholder': 'Rechercher par mot-clé ou numéro…',
  'bills.semanticMode': 'Recherche sémantique',
  'bills.browseMode': 'Navigation structurée',
  'bills.type.motion': 'Motion',
  'bills.type.postulate': 'Postulat',
  'bills.type.interpellation': 'Interpellation',
  'bills.type.parlInit': 'Initiative parlementaire',
  'bills.type.cantonInit': 'Initiative cantonale',
  'bills.type.groupMotion': 'Motion de groupe',
  'bills.type.question': 'Question',
  'bills.type.urgentQuestion': 'Question urgente',
  'bills.type.simpleQuestion': 'Question simple',
  'bills.type.federalBill': 'Objet du Conseil fédéral',
  'bills.type.urgentInterp': 'Interpellation urgente',
  'bills.type.urgentSimple': 'Question urgente simple',
  'bills.type.recommendation': 'Recommandation',
  'bills.type.petition': 'Pétition',
  'bills.type.pag': 'Question de groupe parlementaire',
  'bills.status.submitted': 'Déposé',
  'bills.status.referred': 'Transmis',
  'bills.status.inCommittee': 'En commission',
  'bills.status.planned': 'Planifié',
  'bills.status.finalVote': 'Vote final',
  'bills.status.concluded': 'Liquidé',
  'bills.status.reporting': 'Rapport disponible',
  'bills.status.statement': 'Avis disponible',
  'bills.tab.documents': 'Documents',
  'bills.tab.relatedBusiness': 'Objets connexes',
  'bills.related.linked': 'Liens officiels',
  'bills.related.semantic': 'Similaires sémantiquement',
  'bills.related.noSemantic': 'Aucun objet similaire trouvé.',
  'bills.related.votes': 'Votes liés',
  'bills.tab.related': 'Connexes & Votes',
  'bills.tab.fulltext': 'Texte intégral',
  'bills.tab.council': 'Conseil fédéral',
  'bills.cosignatories': 'Cosignataires',
  'bills.rapporteurs': 'Rapporteurs',
  'bills.preconsultations': 'Commissions compétentes',
  'bills.legislativeDocs': 'Documents législatifs',
  'bills.noDocuments': 'Aucun document législatif disponible.',
  'bills.botschaft': 'Message du Conseil fédéral (Botschaft)',
  // committees
  'committees.title': 'Commissions',
  'committees.subtitle': 'Parcourir les commissions parlementaires et leurs membres',
  'committees.allCouncils': 'Conseils',
  'committees.allCommissions': 'Commissions',
  'committees.national': 'Conseil national',
  'committees.states': 'Conseil des États',
  'committees.members': 'membres',
  'committees.function': 'Fonction',
  'committees.backToList': 'Retour aux commissions',
  'committees.searchPlaceholder': 'Rechercher par nom ou membre…',
  'committees.csv.abbreviation': 'Abréviation',
  'committees.csv.name': 'Nom',
  'committees.csv.council': 'Conseil',
  'committees.csv.type': 'Type',
  'committees.csv.members': 'Membres',
  'committees.filterParty': 'Filtrer par parti',
  'committees.typeAll': 'Types',
  'committees.statusAll': 'Statuts',
  'committees.statusActive': 'Actif',
  'committees.statusInactive': 'Inactif',
  'committees.typePermanent': 'Permanente',
  'committees.typeSpecial': 'Spéciale',
  'committees.typeWorkgroup': 'Groupe de travail',
  'bills.allTypes': 'Types',
  'bills.allStatuses': 'Statuts',
  'bills.allDepartments': 'Départements',
  'bills.exportCSV': 'Exporter les résultats filtrés en CSV',
  'bills.moreFilters': 'Plus de filtres',
  'bills.numberFilter': 'Numéro (ex. 23.4488)',
  'bills.aiFilters': 'Filtres supplémentaires',
  'bills.aiFilters.primaryTopic': 'Thèmes',
  'bills.aiFilters.subTopic': 'Sous-thèmes',
  'bills.aiFilters.intent': 'Intentions',
  'bills.aiFilters.audience': 'Publics',
  'bills.aiFilters.trigger': 'Déclencheurs',
  // Traductions des valeurs d'énumération IA (le backend stocke l'anglais
  // canonique ; localisé pour l'affichage seulement, la valeur canonique est
  // renvoyée à l'API).
  'affairs.intent.newLegislation':  'Nouvelle législation',
  'affairs.intent.revision':        'Révision / Modification',
  'affairs.intent.repeal':          'Abrogation / Suppression',
  'affairs.intent.executive':       'Instruction d’exécution',
  'affairs.intent.reporting':       'Rapport / Enquête',
  'affairs.intent.intlAdaptation':  'Adaptation internationale',
  'affairs.audience.citizens':         'Citoyens (général)',
  'affairs.audience.smes':             'PME / économie locale',
  'affairs.audience.largeEnterprises': 'Grandes entreprises',
  'affairs.audience.publicAdmin':      'Administration publique',
  'affairs.audience.vulnerable':       'Personnes vulnérables',
  'affairs.audience.farmers':          'Agriculture',
  'affairs.audience.healthcare':       'Santé',
  'affairs.audience.education':        'Éducation',
  'affairs.trigger.popularInitiative':  'Initiative populaire / Référendum',
  'affairs.trigger.intlMandates':       'Mandats internationaux (UE/OCDE/ONU)',
  'affairs.trigger.judicialRulings':    'Décisions judiciaires',
  'affairs.trigger.techShift':          'Mutation technologique',
  'affairs.trigger.globalCrisis':       'Crise mondiale',
  'affairs.trigger.internalInitiative': 'Initiative interne',
  'bills.aiFilters.minImpact': 'Impact ≥',
  'bills.aiFilters.minSensitivity': 'Sensibilité ≥',
  'bills.aiFilters.minCentralization': 'Centralisation ≥',
  'bills.aiFilters.browseOnly': 'Les filtres IA s\'appliquent uniquement en mode navigation',
  'bills.intelligence.title': 'Analyse IA',
  'bills.quickStart.title': 'Explorer — ou utiliser la recherche ci-dessus',
  'bills.quickStart.byYear': 'Par année',
  'bills.submittedBy': 'Déposé par…',
  'bills.timeline.submitted': 'Déposé',
  'bills.timeline.preconsultation': 'Préconsultation',
  'bills.timeline.parliamentaryVote': 'Vote parlementaire',
  // votes
  'votes.title': 'Votes',
  'votes.subtitle': 'Parcourir les résumés de votes parlementaires.',
  'votes.councilScope.title': 'Conseil national uniquement',
  'votes.councilScope.tooltip': 'Ces données ne couvrent que les votes nominatifs du Conseil national. Le Conseil des États publie aussi ses votes individuels, mais via une source distincte que l’API de votes du Parlement que nous synchronisons ne comprend pas.',
  'votes.subtitleBusiness':  'Parcourir les votes groupés par objet.',
  'votes.allCouncils': 'Conseils',
  'votes.dataCoverageNote': 'Remarque : les votes nominatifs du Conseil des États sont disponibles à partir de 2022, ceux du Conseil national à partir de la législature 50 (2015). Les législatures antérieures sont ajoutées progressivement.',
  'votes.bothCouncils': 'Les deux conseils ont voté sur cet objet',
  'votes.oneCouncil': 'Seul le {council} a voté sur cet objet',
  'votes.chamberSwitchHint': 'Chaque conseil vote séparément — changez pour voir les membres de l’autre conseil',
  'votes.subtitleHeatmap':   'Matrice groupe × vote — repérer les groupes qui se divisent ou s\'alignent.',
  'votes.subtitleAnalytics': 'Analyses de cohésion, comparaison, dissidence et démographie sur le registre des votes.',
  'votes.analytics.keywordTooltip': 'Restreint les votes sous-jacents par titre d\'objet ou sujet — p. ex. « climat » limite l\'analyse aux votes liés au climat.',
  'votes.analytics.businessNumberPlaceholder': 'N° d\'objet (p. ex. 25.482)',
  'votes.analytics.businessNumberTooltip':     'Restreint l\'analyse aux votes liés à cet objet spécifique.',
  'votes.analytics.scope.totalVotes':    'votes',
  'votes.analytics.scope.finalVote':     'vote final',
  'votes.analytics.scope.finalTooltip':  'Participation consolidée sur tous les {events} événements de vote pour l\'objet {bnum}. Cliquer pour ouvrir le vote final / principal.',
  'votes.tab.search': 'Recherche',
  'votes.viewEvents': 'Événements de vote',
  'votes.viewBusiness': 'Par objet',
  'votes.votingEvents': 'votes',
  'votes.searchPlaceholder': 'Rechercher par titre, objet ou numéro d\'objet (ex. 25.041)…',
  'votes.businessNumberPlaceholder': 'N° d\'objet (ex. 25.3293)',
  'votes.passed': 'Adopté',
  'votes.rejected': 'Rejeté',
  'votes.pending': 'En attente',
  'votes.outcome.accepted': 'Projet adopté',
  'votes.outcome.rejected': 'Projet rejeté',
  'votes.yes': 'Oui',
  'votes.no': 'Non',
  'votes.abstain': 'Abstention',
  'votes.present': 'Présent',
  'votes.notPresent': 'Absent',
  'votes.excused': 'Excusé',
  'votes.breakdown': 'Répartition par groupe',
  'votes.partyBreakdown': 'Répartition par parti',
  'votes.individualVotes': 'Votes individuels',
  'votes.councillors': 'conseillers',
  'votes.showAll': 'Tout afficher',
  'votes.againstFaction': 'Contre le groupe',
  'votes.seeDebates': 'Voir les débats',
  'votes.surpriseFilter': 'Groupe divisé',
  'votes.tie': 'Égalité',
  // Phase 2b — étiquettes de traduction pour les votes inversés
  // (votes finaux d'initiatives populaires, votes procéduraux à mots-clés).
  'votes.invertedBadge': 'Vote inversé',
  'votes.invertedTooltip.popularInitiative': 'Lors des votes finaux sur les initiatives populaires, le Parlement vote sur un décret recommandant le rejet — un Oui adopte le décret de rejet (= contre l\'initiative); un Non rejette le décret (= pour l\'initiative).',
  'votes.invertedTooltip.keywordMatch': 'La question est formulée de telle sorte qu\'un Oui signifie l\'action négative (rejet / non-entrée / pas de suite) — lire Oui comme Contre le projet et Non comme Pour le projet.',
  'votes.invertedTooltip.generic': 'Sur cette ligne, Oui et Non se lisent dans le sens opposé à la position politique sur le projet sous-jacent.',
  'votes.forBill': 'Pour',
  'votes.againstBill': 'Contre',
  'votes.rawMechanicsTooltip': 'Décomptes Oui/Non bruts — mécanique du vote, pas position. Voir la ligne Pour/Contre ci-dessus pour la position traduite sur le projet.',
  'votes.rawDecisionLabel': 'Vote brut',
  'filter.allStances': 'Positions',
  'filter.tooltip.logicalStance': 'Filtrer par position traduite sur le projet. Défini par la navigation depuis le chatbot; effacer ou changer ici.',
  'votes.date': 'Date',
  'votes.passRate': "Taux d'adoption",
  'votes.contestedSub': '≤10 voix d\'écart',
  'votes.perVote': 'conseillers / vote',
  'votes.contested': 'Votes serrés',
  'votes.avgParticipation': 'Participation moy.',
  'votes.closestMargin': 'Marge la plus serrée',
  'votes.closeVotesFilter': 'Votes serrés',
  'votes.finalVoteFilter':  'Votes finaux',
  'votes.finalVoteTag':     'Vote final',
  'votes.finalVoteTooltip': 'Vote final sur l\'objet',
  'votes.meaning.yes':         'Oui',
  'votes.meaning.no':          'Non',
  'votes.meaning.yesAccept':   'Un Oui accepte le projet.',
  'votes.meaning.noReject':    'Un Non rejette le projet.',
  'votes.meaning.yesReject':   'Un Oui rejette l\'objet.',
  'votes.meaning.noAccept':    'Un Non accepte l\'objet.',
  'votes.meaning.stichYes':    'Oui soutient l\'une des deux propositions.',
  'votes.meaning.stichNo':     'Non soutient l\'autre proposition.',
  'votes.meaning.yesGeneric':  'Un Oui approuve la proposition mise au vote.',
  'votes.meaning.noGeneric':   'Un Non rejette la proposition mise au vote.',
  'votes.meaning.invertedNote':'Attention : sur ce vote, le sens du Oui/Non est inversé par rapport à l\'objet.',
  'votes.meaning.stichNote':   'Vote départage : Oui et Non représentent chacun une proposition concurrente, et non l\'acceptation ou le rejet.',
  'filter.tooltip.finalOnly': 'Afficher uniquement les votes finaux — les votes procéduraux et article par article sont exclus.',
  'votes.councillorFilter': 'Conseiller·ère',
  'votes.decisionFilter':   'Décision',
  'votes.meaningYesFilter': 'Oui signifie',
  'votes.speechAlignment':  'Position discours',
  'votes.speechSentiment':  'Sentiment discours',
  'votes.viewHeatmap': 'Carte thermique',
  'votes.viewAnalytics': 'Analytique',
  'votes.heatmapEmpty': 'Aucune donnée disponible.',
  'votes.factionCol': 'Groupe',
  // analytics tab
  'votes.analytics.modes.cohesion':     'Cohésion',
  'votes.analytics.modes.comparison':   'Comparaison',
  'votes.analytics.modes.rebels':       'Dissidents',
  'votes.analytics.modes.demographics': 'Démographie',
  'votes.analytics.allYears':            'Années',
  'votes.analytics.since':               'Depuis',
  'votes.analytics.yearFromTooltip':     'Uniquement les votes à partir de cette année',
  'votes.analytics.keywordPlaceholder':  'Filtrer par mot-clé…',
  'votes.analytics.cohesion.overallLabel':   'Cohésion moy.',
  'votes.analytics.cohesion.overallTooltip': 'Part moyenne des membres du groupe votant avec leur majorité, sur l\'ensemble des votes filtrés.',
  'votes.analytics.cohesion.acrossVotes':    'sur {n} votes',
  'votes.analytics.cohesion.unanimousLabel': 'Unanime',
  'votes.analytics.cohesion.unanimousSub':   '100% de cohésion',
  'votes.analytics.cohesion.unanimousTooltip': 'Votes où le groupe était totalement uni — tous les membres ont voté de la même manière (100% de cohésion).',
  'votes.analytics.cohesion.splitLabel':     'Divisé',
  'votes.analytics.cohesion.splitSub':       '<80% de cohésion',
  'votes.analytics.cohesion.splitTooltip':   'Votes où le groupe était divisé — moins de 80% des membres ont voté avec la majorité de leur propre groupe.',
  'votes.analytics.cohesion.totalVotesLabel':'Votes au total',
  'votes.analytics.cohesion.totalVotesTooltip':'Nombre de votes pris en compte dans cette analyse après les filtres ci-dessus.',
  'votes.analytics.cohesion.trendTitle':     'Cohésion dans le temps',
  'votes.analytics.cohesion.rankedTitle':    'Votes les plus cohésifs',
  'votes.analytics.comparison.pickFactions': 'Groupes',
  'votes.analytics.comparison.overallTitle': 'Cohésion globale par groupe',
  'votes.analytics.comparison.trendTitle':   'Tendance annuelle de cohésion',
  'votes.analytics.comparison.factionCol':   'Groupe',
  'votes.analytics.comparison.cohesionCol':  'Cohésion',
  'votes.analytics.comparison.totalVotesCol':'Votes',
  'votes.analytics.comparison.unanimousCol': 'Unanime',
  'votes.analytics.comparison.splitCol':     'Divisé',
  'votes.analytics.rebels.title':            'Dissidents les plus fréquents',
  'votes.analytics.rebels.allFactions':      'Groupes',
  'votes.analytics.rebels.minVotes':         'min. {n} votes',
  'votes.analytics.rebels.defections':       'dissidences',
  'votes.analytics.rebels.tooltip':          'Une dissidence est un vote contre la majorité de son propre groupe parlementaire. Le taux correspond à la part des votes d\'un membre qui s\'écartent du groupe.',
  'votes.analytics.demographics.title':      'Comportement de vote par groupe',
  'votes.analytics.demographics.bucketCol':  'Groupe',
  'votes.analytics.demographics.yesShareCol':'Part Oui',
  'votes.analytics.demographics.yesShareTooltip':'Part des votes exprimés de ce groupe (Oui, Non et abstentions) qui étaient Oui.',
  'votes.analytics.demographics.yes':        'Oui',
  'votes.analytics.demographics.no':         'Non',
  'votes.analytics.demographics.abstain':    'Abstention',
  'votes.analytics.demographics.total':      'Total',
  'votes.analytics.demographics.groupBy.faction': 'Par groupe',
  'votes.analytics.demographics.groupBy.party':   'Par parti',
  'votes.analytics.demographics.groupBy.canton':  'Par canton',
  'votes.analytics.demographics.groupBy.gender':  'Par genre',
  'votes.analytics.demographics.groupBy.council': 'Par conseil',
  'votes.analytics.demographics.groupBy.tenure':  'Nouveaux vs. vétérans',
  // sessions
  'sessions.title': 'Sessions',
  'sessions.subtitle': 'Rechercher les sessions parlementaires, regroupées par année.',
  'sessions.subtitleFiltered': '{count} sessions · {filters}',
  'sessions.live': 'En direct',
  'sessions.lp': 'LP',
  'sessions.legislativePeriod': 'Législature',
  'sessions.passedTooltip': "Part des votes substantiels de la session pour lesquels le projet a été accepté. Seuls comptent les votes décidant d'un projet — les votes de procédure et de départage sont exclus, et les votes où un « Oui » rejette en réalité une proposition sont comptés selon leur résultat réel.",
  'sessions.passedTooltipBasis': 'Basé sur {decided} votes substantiels sur {total} votes tenus.',
  'sessions.meetings': 'Séances',
  'sessions.agenda': 'Séances & Ordre du jour',
  'sessions.votes': 'Votes',
  'sessions.agendaItems': 'Points à l\'ordre du jour',
  'sessions.totalYes': 'Total oui',
  'sessions.totalNo': 'Total non',
  'sessions.voteCount': 'Nombre de votes',
  'sessions.backToSessions': 'Retour aux sessions',
  'sessions.noSubjects': 'Aucun point à l\'ordre du jour.',
  'sessions.noMeetings': 'Aucune donnée de séance disponible.',
  'sessions.totalVotesCast': 'Total votes exprimés',
  'sessions.voteList': 'Liste des votes',
  'sessions.spring': 'Printemps',
  'sessions.summer': 'Été',
  'sessions.autumn': 'Automne',
  'sessions.winter': 'Hiver',
  'sessions.special': 'Session spéciale',
  'sessions.allSeasons': 'Sessions',
  'sessions.yesNo': 'Oui / Non',
  'sessions.liveBannerTitle': 'Le parlement est en session',
  'sessions.liveBannerEnds': 'Fin',
  'sessions.attendance': 'Présence',
  'sessions.attendanceTip': 'Conseillers classés par taux d\'absence cette session. Filtrer par groupe pour affiner la liste.',
  'sessions.attendanceEmpty': 'Aucune donnée de vote individuel disponible pour cette session.',
  'sessions.calendarGrid': 'Calendrier de session',
  'sessions.items': 'objets',
  'session.discussion.topSpeakers': 'Orateurs les plus actifs',
  'session.discussion.summary':     'Résumé du débat',
  'session.discussion.speeches':    'interventions',
  'session.discussion.avgEmotion':  'Ø émotion',
  'session.topics.policyAreas':     'Domaines politiques',
  'session.topics.keywords':        'Thèmes principaux de cette session',
  // parties
  'parties.title': 'Partis & Groupes',
  'parties.subtitle': 'Répartition des sièges, parité et appartenance aux chambres.',
  'parties.activeMembers': 'Membres actifs',
  'parties.nationalCouncil': 'Conseil national',
  'parties.statesCouncil': 'Conseil des États',
  // Faction code → recognisable party short-name (unity-ranking axis labels)
  'faction.party.V':   'UDC',
  'faction.party.S':   'PS',
  'faction.party.G':   'Verts',
  'faction.party.GL':  'PVL',
  'faction.party.RL':  'PLR',
  'faction.party.M-E': 'Le Centre',
  'faction.party.BD':  'PBD',
  'parties.femalePct': '% femmes',
  'parties.malePct': '% hommes',
  'parties.seatDistribution': 'Répartition des sièges par groupe',
  'parties.nrSrSplit': 'Répartition par chambre et groupe',
  'parties.genderByFaction': 'Genre par groupe',
  'parties.femalePctByFaction': '% femmes par groupe',
  'parties.factionDetails':      'Détails des groupes',
  'parties.ideologicalSpectrum': 'Spectre idéologique (Gauche ↔ Droite)',
  'parties.spectrum.expert': 'Consensus experts',
  'parties.spectrum.data': 'Données de vote',
  'parties.spectrum.dataNote': 'calculé à partir de l\'accord de vote par paires entre groupes parlementaires',
  'parties.spectrum.dataTip': 'Position sur l\'axe gauche-droite dérivée des comportements de vote réels — similitude de vote de chaque groupe avec SVP (droite) vs SP (gauche), normalisée sur [−3, +3].',
  'parties.seats': 'Sièges',
  'parties.female': 'Femmes',
  'parties.parties': 'Partis',
  'parties.viewMembers': 'Voir',
  'parties.cohesion':    'Cohésion',
  'parties.cantonDistribution': 'Répartition cantonale',
  'parties.dominantFaction': 'Groupe dominant',
  // parties — tabs
  'parties.tab.assembly': 'Assemblée fédérale actuelle',
  'parties.tab.assemblyTip': "L'Assemblée fédérale actuelle — le Conseil national et le Conseil des États réunis. Voir le groupe parlementaire dominant par canton et où siège chaque membre dans les deux chambres.",
  'parties.tab.factions': 'Groupes',
  'parties.tab.factionsTip': 'Un groupe parlementaire peut réunir des membres de plusieurs partis. Ex. EVP et Die Mitte siègent dans le groupe M-E.',
  'parties.tab.parties': 'Partis politiques',
  'parties.tab.partiesTip': 'Partis politiques en tant qu\'organisations enregistrées. Le groupe d\'un membre peut différer de son parti si plusieurs partis partagent un groupe.',
  // parties — map
  'parties.mapTooltipSeats': 'sièges',
  'parties.factionFilterTip': 'Mettre en évidence un ou plusieurs groupes parlementaires dans les deux conseils ; les autres sont atténués.',
  'parties.mapTooltipDominant': 'Dominant',
  'parties.mapClickHint': 'Cliquez sur un canton pour mettre en évidence ses membres dans les plans de salle ci-dessous',
  // parties — faction card / drill-down
  'parties.viewFaction': 'Profil du groupe →',
  'parties.noFactions':  'Aucune donnée de groupe disponible.',
  'parties.nonAligned':  'Non-inscrit / Sans parti',
  // parties — political parties tab
  'parties.party.active': 'actif',
  'parties.party.founded': 'Fondé',
  'parties.party.dissolved': 'Dissous',
  'parties.party.noParties': 'Aucune donnée de parti disponible.',
  'parties.party.historical':     'Historique',
  'parties.party.showHistorical': 'Afficher les partis historiques',
  'parties.party.hideHistorical': 'Masquer les partis historiques',
  // parties — KPI cards
  'parties.kpiSubtitle': 'Totaux parlementaires tous groupes confondus',
  'parties.genderBalance': 'Équilibre des genres',
  'parties.avgCohesion': 'Cohésion moy.',
  'parties.acrossFactionsNote': 'tous groupes confondus',
  // parties — chart card titles
  'parties.dominantFactionByCanton': 'Groupe dominant par canton',
  'parties.nrSeatsByFaction': 'Conseil national — Répartition des sièges par groupe',
  'parties.srSeatsByFaction': 'Conseil des États — Répartition des sièges par groupe',
  'parties.dominantPartyByCanton': 'Parti dominant par canton',
  'parties.nrSeatsByParty': 'Conseil national — Répartition des sièges par parti',
  'parties.srSeatsByParty': 'Conseil des États — Répartition des sièges par parti',
  'parties.dominantFactionByCantonTip': 'Le groupe parlementaire le plus fort dans chaque canton selon le nombre de sièges. Cliquez sur un canton pour mettre en évidence ses membres dans les plans de salle ci-dessous.',
  'parties.hemicycleTip': 'Chaque point représente un siège, disposé par groupe parlementaire de gauche à droite. Survolez un point ou cliquez sur un groupe dans la légende pour l\'isoler.',
  'parties.genderByFactionTip': 'Part des femmes dans chaque groupe parlementaire. La ligne pointillée indique la moyenne de l\'ensemble du parlement.',
  'parties.nrSrSplitTip': 'Répartition des sièges de chaque groupe parlementaire entre le Conseil national et le Conseil des États. Activez « vue % » pour comparer les parts plutôt que les sièges absolus.',
  'parties.seatingTip': 'Le vrai plan de la salle — chaque parlementaire à son siège réel, selon le plan des sièges officiel du Parlement. Survolez un siège pour un aperçu ; cliquez pour ouvrir le profil.',
  'parties.seating.seat': 'Siège',
  'parties.seating.noData': 'Aucune donnée de sièges disponible pour l’instant',
  'parties.seating.canton': 'Canton',
  'parties.seating.since': 'Au parlement depuis',
  'parties.seating.years': 'ans',
  'parties.seating.role': 'Fonction',
  'parties.seating.participation': 'Participation aux votes',
  'parties.seating.cohesion': 'Cohésion',
  'parties.seating.committees': 'Commissions',
  'parties.seating.profession': 'Profession',
  'parties.seating.viewProfile': 'Ouvrir le profil',
  'parties.legislature': 'Législature',
  'parties.current': 'actuelle',
  'parties.seatingCurrentBadge': 'Chambre actuelle',
  'parties.pastLegVoteNote': 'Les graphiques de comportement de vote (cohésion, alliances, spectre idéologique) reposent sur les votes nominatifs enregistrés de la législature sélectionnée, dans les deux conseils lorsque disponibles (les votes du Conseil des États ne sont enregistrés que depuis 2022).',
  'parties.currentChamberNote': 'Instantané de la chambre · législature actuelle',
  'parties.analyticsSection': 'Composition & analyse des votes',
  // parties — ideological spectrum
  'parties.naExcluded': 'Non-inscrits (NA) exclus — indépendants sans position idéologique consensuelle.',
  'parties.allianceMatrix': 'Matrice d\'alliance des groupes',
  'parties.allianceMatrixTip': 'Pourcentage de votes où les deux groupes ont voté dans le même sens. 100% = toujours ensemble, 0% = toujours opposés.',
  'parties.allianceMatrixNote': 'Basé sur tous les votes enregistrés.',
  'parties.cohesionTrend': 'Unité des groupes dans le temps',
  'parties.partyUnityTrend': 'Unité des partis dans le temps',
  'parties.cohesionTrendTip': 'Unité de vote des groupes par session parlementaire.',
  'parties.spectrumClosest': 'Idéologiquement les plus proches :',
  'parties.spectrumFurthest': 'Les plus éloignés :',
  'parties.spectrumPtsApart': 'pts d\'écart',
  'parties.spectrumGapNote': 'Écart experts↔votes',
  'parties.votesMoreRight': 'vote plus à droite que perçu',
  'parties.votesMoreLeft': 'vote plus à gauche que perçu',
  // parties — gender chart
  'parties.genderAvgLine': 'Moy. parlement',
  'parties.genderAvgTooltip': 'Moyenne féminine à l\'échelle du parlement',
  // parties — faction table tooltips
  'parties.seatsShareTooltip': 'Part de l\'ensemble des sièges parlementaires',
  'parties.naChambersNote': 'Membres occupant des rôles exécutifs (ex. Conseil fédéral) non rattachés à une chambre parlementaire',
  'parties.cohesionTooltip': 'La cohésion mesure l\'unité de vote d\'un groupe. 100% signifie que tous les membres votent toujours ensemble. Des valeurs plus faibles indiquent des divisions internes. Couleur : vert ≥92%, amber 85–92%, rouge <85%.',
  // parties — party table
  'parties.party.searchPlaceholder': 'Rechercher des partis…',
  'parties.party.noCurrentMembers': 'Actuellement non représenté au parlement',
  'parties.party.nameColumn': 'Parti',
  'parties.party.abbrColumn': 'Abr.',
  'parties.party.factionColumn': 'Groupe',
  'parties.party.factionColumnTitle': 'Groupe parlementaire de ce parti',
  'parties.party.historicalSubtitle': 'Partis ayant une date de dissolution enregistrée — inclut fusions, renommages et organisations dissoutes.',
  // parties — historical era labels
  'parties.party.era.pre1960': 'Avant 1960',
  'parties.party.era.196070': 'Années 1960–70',
  'parties.party.era.198090': 'Années 1980–90',
  'parties.party.era.2000s': 'Années 2000–début 2010',
  'parties.party.era.present': '2015 — présent',
  'parties.party.singular': 'parti',
  'parties.party.plural': 'partis',
  // faction detail page
  'faction.backToParties': 'Retour aux partis',
  'faction.overview': 'Aperçu',
  'faction.members': 'Membres',
  'faction.interests': 'Lobbying & Intérêts',
  'faction.statsNR': 'Conseil national',
  'faction.statsSR': 'Conseil des États',
  'faction.statsFemale': 'Femmes',
  'faction.statsMale': 'Hommes',
  'faction.memberCount': 'membres',
  'faction.interestsByType': 'Intérêts par type',
  'faction.topOrganizations': 'Principales organisations',
  'faction.paid': 'Rémunéré',
  'faction.unpaid': 'Non rémunéré',
  'faction.noInterests': 'Aucune donnée de lobbying disponible pour ce groupe.',
  'faction.councillorsCount': 'conseillers',
  'faction.cantonBreakdown': 'Membres par canton',
  'faction.recentVotes':     'Votes récents',
  'faction.factionVote':     'Vote du groupe',
  // overview
  'overview.title': 'Parlumina',
  'overview.subtitle': 'Données en direct de l\'Assemblée fédérale.',
  'overview.councillors': 'Conseillers',
  'overview.activeAffairs': 'Objets en cours',
  'overview.votesThisYear': 'Votes cette année',
  'overview.currentSession': 'Session actuelle',
  'overview.activityTrends': 'Tendances d\'activité',
  'overview.votesBySession': 'Votes par session',
  'overview.partyComposition': 'Composition des partis',
  'overview.recentDebates': 'Débats récents',
  'overview.passRate': 'Taux d\'adoption (année)',
  'overview.viewAll': 'Tout voir',
  'overview.sessionLive': 'En direct',
  'overview.sessionEnded': 'terminée il y a',
  'overview.sessionUpcoming': 'commence dans',
  'overview.speeches': 'interventions',
  'overview.seats': 'Sièges',
  'overview.hotTopics': 'Récemment discutés',
  'overview.allLang': 'Tous',
  'overview.vsLastSession': 'vs. session précédente',
  'overview.ofVotes': 'sur {n} votes',
  'overview.nrSrSplit': '{nr} CN · {sr} CE · +{br} CF · +{bk} ChF',
  'overview.submittedThisYear': '{n} déposés cette année',
  'overview.allChambers': 'toutes chambres',
  'overview.vsYear': 'vs. {year}',
  'overview.highImpactBills': 'Objets à fort impact',
  'overview.viewDetails': 'Voir les détails',
  'overview.federalPush': 'Pression fédérale',
  'overview.balanced': 'Équilibré',
  'overview.cantonalLean': 'Orientation cantonale',
  'overview.impactTooltipTitle': 'Impact législatif',
  'overview.impactTooltipText': 'Dans quelle mesure ce projet modifie le droit suisse ou la politique publique. Noté 1–10 par IA.',
  'overview.sensitivityTooltipTitle': 'Sensibilité politique',
  'overview.sensitivityTooltipText': 'Degré de controverse politique ou de tension entre partis que ce projet génère. Noté 1–10 par IA.',
  'overview.chart.clickToOpenSession': 'Cliquer pour ouvrir la session',

  // Members table headers (4.8 — gap fixes)
  'member.council': 'Conseil',
  'member.age':     'Âge',

  // Bills — type-tooltip descriptions (4.8 — gap fixes)
  'bills.type.tip.motion':            'Motion — instruction contraignante au Conseil fédéral d\'introduire une législation ou de prendre des mesures.',
  'bills.type.tip.postulate':         'Postulat — recommandation non contraignante invitant le Conseil fédéral à examiner un sujet.',
  'bills.type.tip.interpellation':    'Interpellation — questions écrites au Conseil fédéral nécessitant une réponse écrite formelle.',
  'bills.type.tip.parlInitiative':    'Initiative parlementaire — un membre propose un projet de loi directement, sans passer par le Conseil fédéral.',
  'bills.type.tip.cantonInitiative':  'Initiative cantonale — un canton propose une modification constitutionnelle ou législative fédérale.',
  'bills.type.tip.groupMotion':       'Motion de groupe — motion déposée conjointement par un groupe parlementaire entier.',
  'bills.type.tip.simpleQuestion':    'Question simple — brève question écrite au Conseil fédéral.',
  'bills.type.tip.federalCouncilBill':'Objet du Conseil fédéral — projet de loi introduit directement par l\'exécutif.',
  'bills.type.tip.urgentInterp':      'Interpellation urgente — interpellation nécessitant une réponse urgente.',
  'bills.type.tip.urgentSimple':      'Question simple urgente — brève question écrite urgente au Conseil fédéral.',
  'bills.type.tip.urgentQuestion':    'Question urgente — exige une réponse immédiate du Conseil fédéral.',
  'bills.type.tip.recommendation':    'Recommandation — recommandation non contraignante adressée à une commission ou autorité.',
  'bills.type.tip.petition':          'Pétition — demande adressée au parlement par des citoyens.',
  'bills.type.tip.parlGroupMotion':   'Motion de groupe parlementaire — motion déposée par un groupe parlementaire.',

  // Usage page (admin / developer-only cost dashboard)
  'usage.title':                  'Utilisation',
  'usage.subtitle':               'Consommation de tokens et coût estimé pour tous les clients de chat.',
  'usage.errorLoad':              'Échec du chargement des données d\'utilisation',
  'usage.range.7d':               '7 derniers jours',
  'usage.range.30d':              '30 derniers jours',
  'usage.range.90d':              '90 derniers jours',
  'usage.range.365d':             'Dernière année',
  'usage.kpi.messages':           'Messages',
  'usage.kpi.messagesHint':       'Un par question posée',
  'usage.kpi.apiCalls':           'Appels API',
  'usage.kpi.apiCallsHint':       'Réponses Anthropic (incl. itérations d\'outils)',
  'usage.kpi.estimatedCost':      'Coût estimé',
  'usage.kpi.costPer100':         '{cost} par 100 messages',
  'usage.kpi.totalTokens':        'Total tokens',
  'usage.kpi.titleGenCost':       'Coût gén. titre',
  'usage.kpi.cacheHitRate':       'Taux de cache',
  'usage.kpi.cacheHitRateHint':   '{saved} économisé · {eff} du préfixe cacheable touché',
  'usage.col.hitRate':            'Taux de cache',
  'usage.kpi.titleGenHint':       'Groq Llama 3.1 8B',
  'usage.kpi.users':              'Utilisateurs',
  'usage.legend.input':           'Entrée',
  'usage.legend.output':          'Sortie',
  'usage.legend.cacheRead':       'Cache lu',
  'usage.legend.cacheCreate':     'Cache écrit',
  'usage.perModelTitle':          'Par modèle (agent de chat)',
  'usage.col.model':              'Modèle',
  'usage.col.msgs':               'Msgs',
  'usage.col.input':              'Entrée',
  'usage.col.output':             'Sortie',
  'usage.col.cacheRead':          'Cache lu',
  'usage.col.cacheCreate':        'Cache écrit',
  'usage.col.estCost':            'Coût est.',
  'usage.unknownModel':           'inconnu',
  'usage.titleGenTitle':          'Génération de titre',
  'usage.titleGenNote':           '(Groq, fournisseur séparé)',
  'usage.titleGen.col.sessionsTitled':    'Sessions titrées',
  'usage.titleGen.col.promptTokens':      'Tokens prompt',
  'usage.titleGen.col.completionTokens':  'Tokens completion',
  'usage.pillLabelTitle':                 'Étiquettes des filtres',
  'usage.pillLabelNote':                  '(Groq, par tour — finition UI)',
  'usage.pillLabel.col.turnsLabelled':    'Tours étiquetés',
  'usage.perUserTitle':           'Par utilisateur',
  'usage.perUserCount':           '({count} au total)',
  'usage.showMore':               'Afficher {count} de plus',
  'usage.collapse':               'Réduire',
  'usage.user.col.user':          'Utilisateur',
  'usage.user.col.sessions':      'Sessions',
  'usage.user.col.messages':      'Messages',
  'usage.user.col.apiCalls':      'Appels API',
  'usage.user.col.cacheRW':       'Cache L/É',
  'usage.user.col.costPer100':    '$ / 100 messages',
  'usage.user.col.lastActivity':  'Dernière activité',
  'usage.user.nameUnknown':       'nom inconnu',
  'usage.footnote':               'Message = un échange de conversation : la question de l\'utilisateur + toutes les itérations internes d\'outils + la réponse finale de l\'IA, comptés comme un seul. Appels API est le nombre brut de réponses Anthropic (≥ messages, puisque l\'agent émet un appel API par itération). Coût et tokens sont sommés sur tous les appels. $ / 100 messages est la projection budgétaire — au coût actuel par message, combien coûteraient 100 messages ? Estimations uniquement — la facture réelle du fournisseur peut différer. Génération de titre : Groq Llama 3.1 8B Instant ($0.05 / $0.08 par M). Agent de chat : Anthropic Claude Haiku 4.5 ($1 entrée / $5 sortie par M, lectures de cache $0.10, écritures de cache 5 min $1.25).',

  // ── Page Paramètres ────────────────────────────────────────────────────────
  'settings.title':                  'Paramètres',
  'settings.subtitle':               'Gérez vos préférences, notifications et données système.',
  'settings.manageAccount':          'Gérer le compte',
  'settings.tab.preferences':        'Préférences',
  'settings.tab.notifications':      'Notifications',
  'settings.tab.managePresets':      'Gérer les filtres',
  'settings.tab.system':             'Système',
  'settings.appearance':             'Apparence',
  'settings.theme':                  'Thème',
  'settings.theme.desc':             'Palette de couleurs du tableau de bord.',
  'settings.theme.light':            'Clair',
  'settings.theme.dark':             'Sombre',
  'settings.theme.system':           'Système',
  'settings.language':               'Langue',
  'settings.language.desc':          'Langue des libellés et de l\'interface.',
  'settings.navigation':             'Navigation',
  'settings.landingPage':            'Page d\'accueil par défaut',
  'settings.landingPage.desc':       'Page affichée après la connexion.',
  'settings.aiChat':                 'Chat IA',
  'settings.showWidget':             'Afficher le widget de chat',
  'settings.showWidget.desc':        'Afficher l\'assistant InnoChat sur toutes les pages.',
  'settings.about':                  'À propos',
  'settings.appVersion':             'Version de l\'application',
  'settings.appVersion.desc':        'Parlumina',
  'settings.dataSource':             'Source des données',
  'settings.dataSource.desc':        'Données ouvertes de l\'Assemblée fédérale suisse.',
  'settings.dataUpdated':            'Données mises à jour',
  'settings.dataUpdated.desc':       'Enregistrement le plus récent synchronisé depuis le registre parlementaire.',
  'settings.dataUpdated.unknown':    'Inconnu',
  'settings.aiAssistant':            'Assistant IA',
  'settings.aiAssistant.desc':       'Propulsé par INNOCHAT — la plateforme IA d\'InnoQ.',
  'settings.alertPrefs':             'Préférences d\'alerte',
  'settings.alert.votes':            'Résultats des votes',
  'settings.alert.votes.desc':       'Notifier quand un objet suivi passe au vote final.',
  'settings.alert.bills':            'Changements de statut d\'objet',
  'settings.alert.bills.desc':       'Alerter quand un objet suivi avance ou se conclut.',
  'settings.alert.browser':          'Notifications du navigateur',
  'settings.alert.browser.blocked':  'Bloqué par le navigateur — modifiez dans les paramètres du site.',
  'settings.alert.browser.desc':     'Activer les notifications push dans ce navigateur.',
  'settings.watchlist':              'Liste de suivi',
  'settings.watchlist.members':      'Membres suivis',
  'settings.watchlist.bills':        'Objets suivis',
  'settings.watchlist.empty':        'Rien d\'enregistré pour l\'instant.',
  'settings.watchlist.countOne':     '1 élément enregistré.',
  'settings.watchlist.countMany':    '{n} éléments enregistrés.',
  'settings.watchlist.manage':       'Gérer',
  'settings.tags':                   'Étiquettes',
  'settings.presets.signIn':         'Connectez-vous pour gérer vos filtres enregistrés.',
  'settings.presets.title':          'Filtres enregistrés',
  'settings.presets.empty':          'Aucun filtre enregistré pour le moment. Sur Membres, Objets, Débats ou Votes, définissez les filtres souhaités puis cliquez sur « Enregistrer le filtre » pour les conserver ici.',
  'settings.presets.deleteTooltip':  'Supprimer le filtre',
  'settings.presets.delete':         'Supprimer',
  'settings.presets.updated':        'Mis à jour le {date}',
  'settings.presets.countOne':       '1 filtre',
  'settings.presets.countMany':      '{n} filtres',
  'settings.presets.loadError':      'Échec du chargement des filtres',
  'settings.presets.deleteError':    'Échec de la suppression',
  'settings.developer':              'Développeur',
  'settings.chatProvider':           'Fournisseur du modèle du chatbot',
  'settings.chatProvider.label':     'Fournisseur actif',
  'settings.chatProvider.desc':      'Contrôle développeur. Détermine quel LLM répond au chatbot pour TOUS les utilisateurs — pas seulement vous. Appliqué dès le prochain échange.',
  'settings.chatProvider.anthropic': 'Anthropic (Claude Sonnet)',
  'settings.chatProvider.openai':    'OpenAI (GPT-5.4 mini)',
  'settings.chatProvider.loadError': "Impossible de charger le fournisseur actuel.",
  'settings.chatProvider.saveError': "Impossible de changer de fournisseur. Réessayez.",
  'settings.devInspector':           'Inspecteur dev',
  'settings.devInspector.desc':      'Affiche sous chaque réponse IA les appels d\'outils, arguments et aperçus de résultats de l\'agent. Désactivez pour voir le chat exactement comme un utilisateur lambda.',
  // citations + speech/vote correlation
  'debates.conditional': 'Cond.',
  'citation.type.councillor': 'Profil',
  'citation.type.affair': 'Objet',
  'citation.type.dispatch': 'Message',
  'citation.type.speech': 'Intervention',
  'citation.source': 'Source',
  'citation.aria': 'Source {id} : {label}',
  // chat widget
  'chat.entity.member': 'Conseiller',
  'chat.entity.session': 'Session',
  'chat.entity.bill': 'Objet',
  'chat.entity.vote': 'Vote',
  'chat.entity.debate': 'Débat',
  'chat.entity.faction': 'Groupe',
  'chat.context.dashboard': 'Tableau de bord parlementaire',
  'chat.viewing': 'Affichage :',
  'chat.context.syncActive': 'L\'assistant sait ce que vous consultez — la page en cours, ainsi que les filtres appliqués et les éléments ouverts.',
  'chat.context.syncInactive': 'Aucun contexte de page à partager ici — l\'assistant répond aux questions générales. Ouvrez une page de données pour l\'interroger sur ce que vous consultez.',
  'chat.toast.newSession': 'Nouvelle conversation lancée',
  'chat.fab.aria': 'Ouvrir le chat IA du parlement',
  'chat.collapse': 'Réduire',
  'chat.expand': 'Agrandir',
  'chat.newSession': 'Nouvelle conversation',
  'chat.mode.speed': 'Rapide',
  'chat.mode.quality': 'Qualité',
  'chat.mode.speedTip': 'Réponses rapides — faible latence, bonne qualité',
  'chat.mode.qualityTip': 'Meilleure qualité — réponses plus approfondies, latence plus élevée',
  'chat.dashboardFiltered': 'Tableau de bord filtré :',
  'chat.clearFilter': 'Effacer le filtre',
  'chat.input.placeholder': 'Posez une question sur le parlement…',
  'chat.input.signingIn': 'Connexion…',
  'chat.send': 'Envoyer le message',
  'chat.stop': 'Arrêter la génération',
  'chat.stopped': 'Arrêté.',
  // multi-select control + canton map tooltip
  'multiselect.selected': '{n} sélectionné(s)',
  'multiselect.noOptions': 'Aucune option',
  'cantonMap.dominantParty': 'Parti dominant',
  'cantonMap.faction': 'Groupe',
  'cantonMap.dominantFaction': 'Groupe dominant',
  'cantonMap.party': 'Parti',
  // member activity chart
  'common.pp': 'pp',
  'member.activity.voteParticipation': 'Participation aux votes',
  'member.activity.participation': 'Participation',
  'member.activity.votesOfTotal': '{n} sur {total} votes',
  // localization pass: bill detail / parties / session detail
  'billDetail.typeTip.motion': 'Motion — mandat contraignant au Conseil fédéral d\'élaborer un projet de loi ou d\'agir.',
  'billDetail.typeTip.postulate': 'Postulat — recommandation non contraignante invitant le Conseil fédéral à examiner un objet.',
  'billDetail.typeTip.interpellation': 'Interpellation — questions écrites au Conseil fédéral exigeant une réponse écrite formelle.',
  'billDetail.typeTip.parliamentaryInit': 'Initiative parlementaire — un parlementaire propose un projet directement sans solliciter le Conseil fédéral.',
  'billDetail.typeTip.cantonalInit': 'Initiative cantonale — un canton propose une modification constitutionnelle ou législative fédérale.',
  'billDetail.typeTip.groupMotion': 'Motion de groupe — une motion déposée conjointement par un groupe parlementaire entier.',
  'billDetail.typeTip.simpleQuestion': 'Question simple — une brève question écrite au Conseil fédéral.',
  'billDetail.typeTip.federalCouncilBill': 'Objet du Conseil fédéral — un projet présenté directement par l\'exécutif.',
  'billDetail.typeTip.urgentInterpellation': 'Interpellation urgente — une interpellation exigeant une réponse urgente.',
  'billDetail.typeTip.urgentSimpleQuestion': 'Question simple urgente — une brève question écrite urgente au Conseil fédéral.',
  'billDetail.typeTip.urgentQuestion': 'Question urgente — exige une réponse immédiate du Conseil fédéral.',
  'billDetail.typeTip.recommendation': 'Recommandation — une recommandation non contraignante à une commission ou autorité.',
  'billDetail.typeTip.petition': 'Pétition — une requête adressée au Parlement par des citoyens.',
  'billDetail.typeTip.parliamentaryGroupMotion': 'Motion de groupe parlementaire — une motion déposée par un groupe parlementaire.',
  'billDetail.pipeline.submitted': 'Déposé',
  'billDetail.pipeline.review': 'En examen',
  'billDetail.pipeline.vote': 'Vote final',
  'billDetail.pipeline.concluded': 'Liquidé',
  'billDetail.tab.debates': 'Interventions',
  'billDetail.tab.activity': 'Activité',
  'billDetail.tab.votes': 'Votes',
  'billDetail.tab.similar': 'Objets similaires',
  'billDetail.furtherDocs': 'Documents complémentaires',
  'billDetail.officialBulletin': 'Bulletin officiel',
  'billDetail.notFound': 'Objet introuvable.',
  'billDetail.lp.title': 'Législature',
  'billDetail.meta.status': 'État des délibérations',
  'billDetail.meta.legislativePeriod': 'Législature',
  'billDetail.meta.commission': 'Commission',
  'billDetail.meta.category': 'Catégorie de débat',
  'billDetail.category.I': 'Débat libre',
  'billDetail.category.II': 'Débat organisé',
  'billDetail.category.III': 'Débat de groupe',
  'billDetail.category.IV': 'Débat réduit',
  'billDetail.category.V': 'Procédure réduite',
  'billDetail.lp.tooltip': 'Le mandat de quatre ans de l’Assemblée fédérale durant lequel les membres élus siègent.',
  'billDetail.triggerTip.popularInitiative': 'Initiative populaire — les citoyens peuvent proposer une modification de la Constitution fédérale en réunissant 100 000 signatures valables en 18 mois. Référendum — une loi adoptée par le Parlement peut être soumise au vote populaire si 50 000 signatures sont récoltées en 100 jours.',
  'billDetail.triggerTip.intlMandates': 'Découle d’obligations d’organismes internationaux (UE, OCDE, ONU) que la Suisse doit transposer en droit national.',
  'billDetail.triggerTip.judicialRulings': 'Suscité par une décision de justice (p. ex. du Tribunal fédéral ou de la CEDH) exigeant une adaptation de la législation.',
  'billDetail.triggerTip.techShift': 'Une réponse à de nouvelles technologies ou évolutions numériques que le droit en vigueur ne couvre pas encore.',
  'billDetail.triggerTip.globalCrisis': 'Déclenché par une crise internationale (pandémie, guerre, choc financier) appelant une réponse législative.',
  'billDetail.triggerTip.internalInitiative': 'Provient du Parlement ou de l’administration fédérale plutôt que d’un événement externe.',
  'billDetail.triggerTip.generic': 'L’événement ou le processus externe à l’origine de cet objet parlementaire.',
  'billDetail.tags.label': 'Thèmes',
  'billDetail.debates.councilFilter': 'Conseil',
  'billDetail.debates.showingRange': 'Interventions {from}–{to} sur {total}',
  'billDetail.debates.pageOf': 'Page {page} sur {pages}',
  'billDetail.meta.submitted': 'Déposé',
  'billDetail.meta.statusDate': 'Date du statut',
  'billDetail.description': 'Description',
  'billDetail.noShortDescription': 'Aucune description succincte disponible pour cet objet.',
  'billDetail.viewFullText': 'Voir le texte intégral',
  'billDetail.submittedTo': 'Déposé auprès de : ',
  'billDetail.activityTimeline': 'Chronologie des activités',
  'billDetail.fullText.initialSituation': 'Situation initiale',
  'billDetail.fullText.submittedText': 'Texte déposé',
  'billDetail.fullText.reason': 'Développement / Motivation',
  'billDetail.fullText.motion': 'Proposition / Requête',
  'billDetail.noFullText': 'Aucun texte intégral disponible.',
  'billDetail.proposalCode': 'Code de la proposition',
  'billDetail.council.response': 'Avis du Conseil fédéral',
  'billDetail.council.proposalText': 'Texte de la proposition',
  'billDetail.council.proposal': 'Proposition du Conseil fédéral',
  'billDetail.council.proposalCodeTip': 'Le code utilisé par les données parlementaires officielles pour la proposition du Conseil fédéral (p. ex. 44 = adoption, 45 = rejet, 46 = adoption partielle). Le libellé en indique la signification.',
  'billDetail.council.proceedings': 'Délibérations',
  'billDetail.council.noResponse': 'Aucun avis du Conseil fédéral disponible.',
  'billDetail.debates.loadError': 'Impossible de charger les débats. L\'index de recherche est peut-être temporairement indisponible.',
  'billDetail.debates.empty': 'Aucune intervention parlementaire trouvée pour cet objet.',
  'billDetail.debates.emptyChamber': 'Aucune intervention de ce conseil pour cet objet.',
  'billDetail.votes.emptyChamber': 'Aucun vote de ce conseil pour cet objet.',
  'billDetail.debates.stateRep': 'Repr. du canton',
  'billDetail.debates.amendmentProposed': 'Amendement proposé',
  'billDetail.debates.amendment': 'amendement',
  'billDetail.debates.emotionality': 'Émotivité',
  'parties.noData': 'Aucune donnée',
  'parties.totalSuffix': 'au total',
  'parties.nrSeats': 'sièges CN',
  'parties.srSeats': 'sièges CE',
  'parties.csv.abbreviation': 'Abréviation',
  'parties.csv.name': 'Nom',
  'parties.csv.total': 'Total',
  'parties.csv.nr': 'CN',
  'parties.csv.sr': 'CE',
  'parties.csv.female': 'Femmes',
  'parties.csv.male': 'Hommes',
  'parties.csv.cohesion': 'Cohésion (%)',
  'parties.csv.activeMembers': 'Membres actifs',
  'parties.csv.founded': 'Fondé',
  'parties.avg': 'Moy.',
  'parties.spectrum.left': 'Gauche',
  'parties.spectrum.right': 'Droite',
  'parties.selfAlways100': 'Soi-même — toujours 100%',
  'parties.agreement': 'Concordance',
  'parties.recordedVotesCount': '{a} sur {b} votes enregistrés',
  'parties.recordedVotes': 'votes enregistrés',
  'parties.cohesionAxis': 'Unité (%)',
  'parties.threshold90': 'seuil de 90%',
  'parties.chamber.nr': 'Conseil national',
  'parties.chamber.sr': 'Conseil des États',
  'parties.cohesionNoChamberData': 'Aucune donnée de cohésion du Conseil des États pour cette période — les votes nominatifs n\'existent que depuis 2022.',
  'parties.filteredBy': 'Filtré par :',
  'parties.filtered': 'Filtré :',
  'parties.nonAlignedFootnote': '{count} non-inscrits non affichés — ces membres exercent des fonctions exécutives (Conseil fédéral) non rattachées à une chambre parlementaire.',
  'parties.pctView': 'vue en %',
  'parties.sort': 'Trier :',
  'parties.sortLeftRight': 'Gauche → Droite',
  'parties.sortAlphabetical': 'Alphabétique',
  'parties.self': 'Soi-même',
  'parties.seatsProportionTitle': 'Proportion de l\'ensemble des sièges parlementaires',
  'parties.nrShort': 'CN',
  'parties.srShort': 'CE',
  'parties.notAffiliatedTitle': 'Membres sans affiliation à un parti enregistré',
  'sessionDetail.councilVbv': 'VBV',
  'sessionDetail.councilVbvFull': 'Chambres réunies',
  'sessionDetail.noSrVotes': "Aucun vote nominatif du Conseil des États n'est enregistré pour cette session (disponible à partir de 2022).",
  'sessionDetail.donutTooltip': "Somme de tous les bulletins Oui / Non / abstention exprimés sur l'ensemble des votes nominatifs de cette session — total des bulletins, et non le nombre de votes.",
  'sessionDetail.kpiAcceptedTooltip': "Combien de votes décisifs de la session se sont terminés par l'acceptation du projet (et leur part). Les votes de procédure et de départage sont exclus ; les votes où un « Oui » signifie un rejet sont comptés selon leur résultat réel.",
  'sessionDetail.kpiRejectedTooltip': "Combien de votes décisifs se sont terminés par le rejet du projet (et leur part). Même base que le chiffre des acceptations — hors votes de procédure et de départage.",
  'sessionDetail.kpiParticipationTooltip': "Nombre moyen de membres du conseil votant Oui, Non ou abstention par vote — c'est-à-dire les présents. Les absences et excuses ne sont pas comptées.",
  'sessionDetail.calendarCountHint': 'Le nombre à côté de chaque conseil (p. ex. NR · 11) indique le nombre d’objets traités ce jour-là.',
  'sessionDetail.noSession': 'Pas de séance',
  'sessionDetail.passRate': 'Taux d\'acceptation',
  'sessionDetail.searchAgenda': 'Rechercher parmi {n} points à l\'ordre du jour…',
  'sessionDetail.avgParticipation': 'Participation moyenne',
  'sessionDetail.councillorsPerVote': 'conseillers / vote',
  'sessionDetail.votesPerDay': 'Votes par jour',
  'sessionDetail.mostContested': 'Les plus disputés',
  'sessionDetail.margin': 'écart',
  'sessionDetail.colAffair': 'Objet',
  'sessionDetail.colTitle': 'Titre',
  'sessionDetail.colResult': 'Résultat',
  'sessionDetail.viewVoteBreakdown': 'Voir le détail du vote',
  'sessionDetail.absent': 'absent',
  'sessionDetail.votes': 'votes',
  'sessionDetail.totalAgendaItems': 'Total des points à l\'ordre du jour',
  'common.weekday.mon': 'lun',
  'common.weekday.tue': 'mar',
  'common.weekday.wed': 'mer',
  'common.weekday.thu': 'jeu',
  'common.weekday.fri': 'ven',
  'common.weekday.sat': 'sam',
  // localization pass 2: votes / members / bills / sessions / debates
  'votes.stichfrage': 'Question subsidiaire',
  'votes.yesShort': 'O',
  'votes.noShort': 'N',
  'votes.factionSplit': 'Groupe divisé',
  'votes.noData': 'aucune donnée',
  'votes.voteNumber': 'Vote n° ',
  'voteDetail.sortYesPct': 'O %',
  'voteDetail.sortNoPct': 'N %',
  'voteDetail.sortAbstain': 'A',
  'voteDetail.sortTotal': '#',
  'voteDetail.sortName': 'A–Z',
  'voteDetail.sortLabel': 'Trier',
  'voteDetail.filterLabel': 'Filtrer',
  'voteDetail.sortYesPctTip': 'Trier par part de votes Oui de chaque groupe (plus élevé d’abord)',
  'voteDetail.sortNoPctTip': 'Trier par part de votes Non de chaque groupe (plus élevé d’abord)',
  'voteDetail.sortAbstainTip': 'Trier par abstentions — présents n’ayant voté ni Oui ni Non',
  'voteDetail.sortTotalTip': 'Trier par nombre total de membres de chaque groupe',
  'voteDetail.sortNameTip': 'Trier par ordre alphabétique du nom',
  'voteDetail.filterAllTip': 'Afficher tous les groupes',
  'voteDetail.filterYesTip': 'Uniquement les groupes dont la majorité a voté Oui',
  'voteDetail.filterNoTip': 'Uniquement les groupes dont la majorité a voté Non',
  'voteDetail.filterSplitTip': 'Uniquement les groupes à égalité — autant de Oui que de Non',
  'voteDetail.csvFirstName': 'Prénom',
  'voteDetail.csvLastName': 'Nom',
  'voteDetail.csvCanton': 'Canton',
  'voteDetail.csvFaction': 'Groupe',
  'voteDetail.csvDecision': 'Décision',
  'voteDetail.csvDecisionCode': 'Code de décision',
  'voteDetail.abstainShort': 'A',
  'voteDetail.absentShort': 'abs.',
  'voteAnalytics.cohesionSuffix': 'cohésion',
  'faction.notFound': 'Groupe introuvable.',
  'faction.partyComposition': 'Composition partisane',
  'faction.memberSearchPlaceholder': 'Filtrer par nom, canton, parti…',
  'faction.canton': 'Canton',
  'faction.subjectCol': 'Objet',
  'faction.organizationCol': 'Organisation',
  'faction.compensationCol': 'Rémunération',
  'faction.interestsClickHint': 'Cliquez sur une barre ou une étiquette pour filtrer les organisations ci-dessous.',
  'faction.typeCol': 'Type',
  'faction.totalSuffix': 'au total',
  'members.csv.name': 'Nom',
  'members.csv.party': 'Parti',
  'members.csv.faction': 'Groupe',
  'members.csv.canton': 'Canton',
  'members.csv.council': 'Conseil',
  'members.csv.active': 'Actif',
  'members.appliedByChatbot': 'Appliqué par le chatbot',
  'bills.csv.number': 'Numéro',
  'bills.csv.title': 'Titre',
  'bills.csv.type': 'Type',
  'bills.csv.status': 'Statut',
  'bills.csv.submissionDate': 'Date de dépôt',
  'bills.scoreDots.impactDescription': 'Dans quelle mesure cet objet affecte la société, l\'économie ou les politiques publiques.',
  'bills.scoreDots.sensitivityDescription': 'À quel point cet objet risque d\'être politiquement contesté ou clivant.',
  'common.other': 'Autre',
  'memberDetail.speechCount': '{count} interventions',
  'memberCompare.remove': 'Retirer',
  'sessions.csv.session': 'Session',
  'sessions.csv.abbreviation': 'Abréviation',
  'sessions.csv.type': 'Type',
  'sessions.csv.startDate': 'Date de début',
  'sessions.csv.endDate': 'Date de fin',
  'sessions.csv.legislativePeriod': 'Législature',
  'sessions.csv.votes': 'Votes',
  'sessions.csv.passRate': 'Taux d\'adoption (%)',
  'sessions.passRateComparison': 'Comparaison du taux d\'adoption',
  'sessions.comparisonTitle': 'Comparaison de session',
  'sessions.vsLastSession': 'vs. session précédente',
  'sessions.vsSameSeasonLastYear': 'vs. même session l\'an dernier',
  'sessions.passRateSuffix': '% adoptés',
  'debates.csv.date': 'Date',
  'debates.csv.speaker': 'Orateur',
  'debates.csv.faction': 'Groupe',
  'debates.csv.canton': 'Canton',
  'debates.csv.council': 'Conseil',
  'debates.csv.businessNumber': 'Numéro d\'objet',
  'debates.csv.businessTitle': 'Titre de l\'objet',
  'debateDetail.missingSpeechId': 'Identifiant d\'intervention manquant. Accédez à cette page depuis une carte de débat.',
  'debateDetail.role.proponent': 'Partisan',
  'debateDetail.role.critic': 'Critique',
  'debateDetail.role.expert': 'Expert',
  'debateDetail.role.mediator': 'Médiateur',
  'debateDetail.role.stateRep': 'Repr. exécutif',
  'debateDetail.role.proponentDesc': 'Plaide en faveur du projet débattu — le défend ou en promeut l’adoption.',
  'debateDetail.role.criticDesc': 'S’exprime de manière critique contre le projet — soulève des objections ou une opposition. Décrit le ton rhétorique de l’intervention, pas nécessairement le vote du membre.',
  'debateDetail.role.expertDesc': 'S’exprime en tant qu’expert du sujet — explique ou clarifie sans prendre parti.',
  'debateDetail.role.mediatorDesc': 'Cherche le compromis ou rapproche les positions opposées du débat.',
  'debateDetail.role.stateRepDesc': 'S’exprime au nom du gouvernement / Conseil fédéral (p. ex. un conseiller fédéral), non comme membre d’un groupe.',
  'debateDetail.role.rapporteur': 'Rapporteur',
  'debateDetail.role.rapporteurDesc': 'Porte-parole officiel de la commission — présente la position formelle de la commission au plénum, et non une position personnelle.',
  'debateDetail.role.procedural': 'Procédure',
  'debateDetail.role.proceduralDesc': 'Intervient sur la procédure (rappels au règlement, ordre du jour, modalités de vote) plutôt que sur le fond.',
  'debateDetail.role.aiNote': 'Classé par IA à partir du texte de l’intervention. Peut différer du vote réel du membre.',
  'debateDetail.sentiment.positive': 'Positif',
  'debateDetail.sentiment.neutral': 'Neutre',
  'debateDetail.sentiment.negative': 'Négatif',
  'debateDetail.sentiment.positiveDesc': 'Le ton émotionnel général de l’intervention est positif — approbateur, optimiste ou favorable dans sa formulation.',
  'debateDetail.sentiment.neutralDesc': 'Le ton émotionnel général de l’intervention est neutre — factuel ou équilibré, sans forte charge positive ou négative.',
  'debateDetail.sentiment.negativeDesc': 'Le ton émotionnel général de l’intervention est négatif — critique, désapprobateur ou pessimiste dans sa formulation. Reflète le ton, pas nécessairement la position du membre.',
  'debateDetail.emotionality.tooltip': 'Le degré de charge émotionnelle du langage de l’intervention, sur une échelle de 0 à 10. Les scores élevés indiquent une formulation plus vigoureuse et passionnée ; les scores faibles, un ton mesuré et factuel.',
  'debateDetail.alignment.forDesc': 'L’intervention soutient le projet débattu — plaide pour son adoption.',
  'debateDetail.alignment.againstDesc': 'L’intervention s’oppose au projet débattu — plaide contre son adoption.',
  'debateDetail.alignment.neutralDesc': 'L’intervention ne prend pas clairement position pour ou contre le projet.',
  'debateDetail.alignment.conditionalDesc': 'L’intervention soutient le projet seulement sous certaines conditions ou modifications.',
  'committee.memberHeading': 'Membre',
  // localization pass 3: notifications / layout / cards / misc components
  'notif.unread': 'non lu',
  'notif.ago.seconds': 'il y a {n} s',
  'notif.ago.minutes': 'il y a {n} min',
  'notif.ago.hours': 'il y a {n} h',
  'notif.ago.days': 'il y a {n} j',
  'doc.permalink': 'Lien permanent',
  'doc.breadcrumb': 'Fil d\'Ariane',
  'doc.copy': 'Copier',
  'doc.copyCode': 'Copier le code',
  'layout.expandSidebar': 'Déployer la barre latérale',
  'layout.collapseSidebar': 'Réduire la barre latérale',
  'topbar.signIn': 'Se connecter',
  'tags.removeTag': 'Supprimer l\'étiquette',
  'tags.defaultColor': 'par défaut',
  'card.untitledAffair': '(objet sans titre)',
  'card.councillor': 'Conseiller',
  'card.unknownCouncillor': 'Inconnu',
  'statusBadge.unknown': 'Inconnu',
  'filterPreset.saveFailed': 'Échec de l\'enregistrement',
  'devInspector.toolCall': '{count} appel d\'outil',
  'devInspector.toolCalls': '{count} appels d\'outils',
  'devInspector.iter': '{count} itér.',
  'devInspector.iterationLine': 'Itér. {iteration} · modèle {modelMs}ms · outils {toolMs}ms',
  'devInspector.argsCount': '{count} args',
  'devInspector.args': 'args',
  'devInspector.resultPreview': 'aperçu du résultat',
  'chat.thinking': 'Réflexion',
};

export default fr;
